// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/blank.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/loading.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("spritesheet.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("images/tabs_icons.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("images/calendar_arrows.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("images/slider_handle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("images/tree_icons.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("images/validatebox_warning.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#requestDaysOnOffModal .panel {
  overflow: hidden;
  text-align: left;
  margin: 0;
  border: 0;
  -moz-border-radius: 0 0 0 0;
  -webkit-border-radius: 0 0 0 0;
  border-radius: 0 0 0 0;
}
#requestDaysOnOffModal .panel-header,
#requestDaysOnOffModal .panel-body {
  border-width: 1px;
  border-style: solid;
}
#requestDaysOnOffModal .panel-header {
  padding: 5px;
  position: relative;
}
#requestDaysOnOffModal .panel-title {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
}
#requestDaysOnOffModal .panel-header-noborder {
  border-width: 0 0 1px 0;
}
#requestDaysOnOffModal .panel-body {
  overflow: auto;
  border-top-width: 0;
  padding: 0;
}
#requestDaysOnOffModal .panel-body-noheader {
  border-top-width: 1px;
}
#requestDaysOnOffModal .panel-body-noborder {
  border-width: 0px;
}
#requestDaysOnOffModal .panel-with-icon {
  padding-left: 18px;
}
#requestDaysOnOffModal .panel-icon,
#requestDaysOnOffModal .panel-tool {
  position: absolute;
  top: 50%;
  margin-top: -8px;
  height: 16px;
  overflow: hidden;
}
#requestDaysOnOffModal .panel-icon {
  left: 5px;
  width: 16px;
}
#requestDaysOnOffModal .panel-tool {
  right: 5px;
  width: auto;
}
#requestDaysOnOffModal .panel-tool a {
  display: inline-block;
  width: 16px;
  height: 16px;
  opacity: 0.6;
  filter: alpha(opacity=60);
  margin: 0 0 0 2px;
  vertical-align: top;
}
#requestDaysOnOffModal .panel-tool a:hover {
  opacity: 1;
  filter: alpha(opacity=100);
  background-color: #E6E6E6;
  -moz-border-radius: -2px -2px -2px -2px;
  -webkit-border-radius: -2px -2px -2px -2px;
  border-radius: -2px -2px -2px -2px;
}
#requestDaysOnOffModal .panel-loading {
  padding: 11px 0px 10px 30px;
}
#requestDaysOnOffModal .panel-noscroll {
  overflow: hidden;
}
#requestDaysOnOffModal .panel-fit,
#requestDaysOnOffModal .panel-fit body {
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  overflow: hidden;
}
#requestDaysOnOffModal .panel-loading {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 10px 10px;
}
#requestDaysOnOffModal .panel-tool-close {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -109px -151px;
}
#requestDaysOnOffModal .panel-tool-min {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -31px -177px;
}
#requestDaysOnOffModal .panel-tool-max {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -5px -177px;
}
#requestDaysOnOffModal .panel-tool-restore {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -57px -177px;
}
#requestDaysOnOffModal .panel-tool-collapse {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -135px -151px;
}
#requestDaysOnOffModal .panel-tool-expand {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -161px -151px;
}
#requestDaysOnOffModal .panel-header,
#requestDaysOnOffModal .panel-body {
  border-color: #ddd;
}
#requestDaysOnOffModal .panel-header {
  background-color: #ffffff;
}
#requestDaysOnOffModal .panel-body {
  background-color: #fff;
  color: #444;
  font-size: 12px;
}
#requestDaysOnOffModal .panel-title {
  font-size: 12px;
  font-weight: bold;
  color: #777;
  height: 16px;
  line-height: 16px;
}
#requestDaysOnOffModal .accordion {
  overflow: hidden;
  border-width: 1px;
  border-style: solid;
}
#requestDaysOnOffModal .accordion .accordion-header {
  border-width: 0 0 1px;
  cursor: pointer;
}
#requestDaysOnOffModal .accordion .accordion-body {
  border-width: 0 0 1px;
}
#requestDaysOnOffModal .accordion-noborder {
  border-width: 0;
}
#requestDaysOnOffModal .accordion-noborder .accordion-header {
  border-width: 0 0 1px;
}
#requestDaysOnOffModal .accordion-noborder .accordion-body {
  border-width: 0 0 1px;
}
#requestDaysOnOffModal .accordion-collapse {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -31px -57px;
}
#requestDaysOnOffModal .accordion-expand {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -135px -31px;
}
#requestDaysOnOffModal .accordion {
  background: #fff;
  border-color: #ddd;
}
#requestDaysOnOffModal .accordion .accordion-header {
  background: #ffffff;
  filter: none;
}
#requestDaysOnOffModal .accordion .accordion-header-selected {
  background: #CCE6FF;
}
#requestDaysOnOffModal .accordion .accordion-header-selected .panel-title {
  color: #000;
}
#requestDaysOnOffModal .window {
  overflow: hidden;
  padding: 5px;
  border-width: 1px;
  border-style: solid;
}
#requestDaysOnOffModal .window .window-header {
  background: transparent;
  padding: 0px 0px 6px 0px;
}
#requestDaysOnOffModal .window .window-body {
  border-width: 1px;
  border-style: solid;
  border-top-width: 0px;
}
#requestDaysOnOffModal .window .window-body-noheader {
  border-top-width: 1px;
}
#requestDaysOnOffModal .window .window-header .panel-icon,
#requestDaysOnOffModal .window .window-header .panel-tool {
  top: 50%;
  margin-top: -11px;
}
#requestDaysOnOffModal .window .window-header .panel-icon {
  left: 1px;
}
#requestDaysOnOffModal .window .window-header .panel-tool {
  right: 1px;
}
#requestDaysOnOffModal .window .window-header .panel-with-icon {
  padding-left: 18px;
}
#requestDaysOnOffModal .window-proxy {
  position: absolute;
  overflow: hidden;
}
#requestDaysOnOffModal .window-proxy-mask {
  position: absolute;
  filter: alpha(opacity=5);
  opacity: 0.05;
}
#requestDaysOnOffModal .window-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  filter: alpha(opacity=40);
  opacity: 0.40;
  font-size: 1px;
  *zoom: 1;
  overflow: hidden;
}
#requestDaysOnOffModal .window,
#requestDaysOnOffModal .window-shadow {
  position: absolute;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .window-shadow {
  background: #eee;
  -moz-box-shadow: 2px 2px 3px #ededed;
  -webkit-box-shadow: 2px 2px 3px #ededed;
  box-shadow: 2px 2px 3px #ededed;
  filter: progid:DXImageTransform.Microsoft.Blur(pixelRadius=2,MakeShadow=false,ShadowOpacity=0.2);
}
#requestDaysOnOffModal .window,
#requestDaysOnOffModal .window .window-body {
  border-color: #ddd;
}
#requestDaysOnOffModal .window {
  background-color: #ffffff;
}
#requestDaysOnOffModal .window-proxy {
  border: 1px dashed #ddd;
}
#requestDaysOnOffModal .window-proxy-mask,
#requestDaysOnOffModal .window-mask {
  background: #eee;
}
#requestDaysOnOffModal .dialog-content {
  overflow: auto;
}
#requestDaysOnOffModal .dialog-toolbar {
  padding: 2px 5px;
}
#requestDaysOnOffModal .dialog-tool-separator {
  float: left;
  height: 24px;
  border-left: 1px solid #ddd;
  border-right: 1px solid #fff;
  margin: 2px 1px;
}
#requestDaysOnOffModal .dialog-button {
  padding: 5px;
  text-align: right;
}
#requestDaysOnOffModal .dialog-button .l-btn {
  margin-left: 5px;
}
#requestDaysOnOffModal .dialog-toolbar,
#requestDaysOnOffModal .dialog-button {
  background: #fff;
}
#requestDaysOnOffModal .dialog-toolbar {
  border-bottom: 1px solid #ddd;
}
#requestDaysOnOffModal .dialog-button {
  border-top: 1px solid #ddd;
}
#requestDaysOnOffModal .textbox {
  border: 1px solid #ddd;
  vertical-align: middle;
}
#requestDaysOnOffModal .combo {
  display: inline-block;
  white-space: nowrap;
  margin: 0;
  padding: 0;
  border-width: 1px;
  border-style: solid;
  overflow: hidden;
  vertical-align: middle;
}
#requestDaysOnOffModal .combo .combo-text {
  font-size: 12px;
  border: 0px;
  line-height: 20px;
  height: 20px;
  margin: 0;
  padding: 0px 2px;
  *margin-top: -1px;
  *height: 18px;
  *line-height: 18px;
  _height: 18px;
  _line-height: 18px;
  vertical-align: baseline;
}
#requestDaysOnOffModal .combo-arrow {
  width: 18px;
  height: 20px;
  overflow: hidden;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  opacity: 0.6;
  filter: alpha(opacity=60);
}
#requestDaysOnOffModal .combo-arrow-hover {
  opacity: 1.0;
  filter: alpha(opacity=100);
}
#requestDaysOnOffModal .combo-panel {
  overflow: auto;
}
#requestDaysOnOffModal .combo-arrow {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -94px -5px;
}
#requestDaysOnOffModal .combo,
#requestDaysOnOffModal .combo-panel {
  background-color: #fff;
}
#requestDaysOnOffModal .combo {
  border-color: #ddd;
  background-color: #fff;
}
#requestDaysOnOffModal .combo-arrow {
  background-color: #ffffff;
}
#requestDaysOnOffModal .combo-arrow-hover {
  background-color: #E6E6E6;
}
#requestDaysOnOffModal .combobox-item,
#requestDaysOnOffModal .combobox-group {
  font-size: 12px;
  padding: 3px;
  padding-right: 0px;
}
#requestDaysOnOffModal .combobox-item-disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
}
#requestDaysOnOffModal .combobox-gitem {
  padding-left: 10px;
}
#requestDaysOnOffModal .combobox-group {
  font-weight: bold;
}
#requestDaysOnOffModal .combobox-item-hover {
  background-color: #E6E6E6;
  color: #444;
}
#requestDaysOnOffModal .combobox-item-selected {
  background-color: #CCE6FF;
  color: #000;
}
#requestDaysOnOffModal .layout {
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  z-index: 0;
}
#requestDaysOnOffModal .layout-panel {
  position: absolute;
  overflow: hidden;
}
#requestDaysOnOffModal .layout-panel-east,
#requestDaysOnOffModal .layout-panel-west {
  z-index: 2;
}
#requestDaysOnOffModal .layout-panel-north,
#requestDaysOnOffModal .layout-panel-south {
  z-index: 3;
}
#requestDaysOnOffModal .layout-expand {
  position: absolute;
  padding: 0px;
  font-size: 1px;
  cursor: pointer;
  z-index: 1;
}
#requestDaysOnOffModal .layout-expand .panel-header,
#requestDaysOnOffModal .layout-expand .panel-body {
  background: transparent;
  filter: none;
  overflow: hidden;
}
#requestDaysOnOffModal .layout-expand .panel-header {
  border-bottom-width: 0px;
}
#requestDaysOnOffModal .layout-split-proxy-h,
#requestDaysOnOffModal .layout-split-proxy-v {
  position: absolute;
  font-size: 1px;
  display: none;
  z-index: 5;
}
#requestDaysOnOffModal .layout-split-proxy-h {
  width: 5px;
  cursor: e-resize;
}
#requestDaysOnOffModal .layout-split-proxy-v {
  height: 5px;
  cursor: n-resize;
}
#requestDaysOnOffModal .layout-mask {
  position: absolute;
  background: #fafafa;
  filter: alpha(opacity=10);
  opacity: 0.10;
  z-index: 4;
}
#requestDaysOnOffModal .layout-button-up {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -31px -57px;
}
#requestDaysOnOffModal .layout-button-down {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -135px -31px;
}
#requestDaysOnOffModal .layout-button-left {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -161px -31px;
}
#requestDaysOnOffModal .layout-button-right {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -5px -57px;
}
#requestDaysOnOffModal .layout-split-proxy-h,
#requestDaysOnOffModal .layout-split-proxy-v {
  background-color: #b3b3b3;
}
#requestDaysOnOffModal .layout-split-north {
  border-bottom: 5px solid #fff;
}
#requestDaysOnOffModal .layout-split-south {
  border-top: 5px solid #fff;
}
#requestDaysOnOffModal .layout-split-east {
  border-left: 5px solid #fff;
}
#requestDaysOnOffModal .layout-split-west {
  border-right: 5px solid #fff;
}
#requestDaysOnOffModal .layout-expand {
  background-color: #ffffff;
}
#requestDaysOnOffModal .layout-expand-over {
  background-color: #ffffff;
}
#requestDaysOnOffModal .tabs-container {
  overflow: hidden;
}
#requestDaysOnOffModal .tabs-header {
  border-width: 1px;
  border-style: solid;
  border-bottom-width: 0;
  position: relative;
  padding: 0;
  padding-top: 2px;
  overflow: hidden;
}
#requestDaysOnOffModal .tabs-header-plain {
  border: 0;
  background: transparent;
}
#requestDaysOnOffModal .tabs-scroller-left,
#requestDaysOnOffModal .tabs-scroller-right {
  position: absolute;
  top: auto;
  bottom: 0;
  width: 18px;
  font-size: 1px;
  display: none;
  cursor: pointer;
  border-width: 1px;
  border-style: solid;
}
#requestDaysOnOffModal .tabs-scroller-left {
  left: 0;
}
#requestDaysOnOffModal .tabs-scroller-right {
  right: 0;
}
#requestDaysOnOffModal .tabs-tool {
  position: absolute;
  bottom: 0;
  padding: 1px;
  overflow: hidden;
  border-width: 1px;
  border-style: solid;
}
#requestDaysOnOffModal .tabs-header-plain .tabs-tool {
  padding: 0 1px;
}
#requestDaysOnOffModal .tabs-wrap {
  position: relative;
  left: 0;
  overflow: hidden;
  width: 100%;
  margin: 0;
  padding: 0;
}
#requestDaysOnOffModal .tabs-scrolling {
  margin-left: 18px;
  margin-right: 18px;
}
#requestDaysOnOffModal .tabs-disabled {
  opacity: 0.3;
  filter: alpha(opacity=30);
}
#requestDaysOnOffModal .tabs {
  list-style-type: none;
  height: 26px;
  margin: 0px;
  padding: 0px;
  padding-left: 4px;
  width: 5000px;
  border-style: solid;
  border-width: 0 0 1px 0;
}
#requestDaysOnOffModal .tabs li {
  float: left;
  display: inline-block;
  margin: 0 4px -1px 0;
  padding: 0;
  position: relative;
  border: 0;
}
#requestDaysOnOffModal .tabs li a.tabs-inner {
  display: inline-block;
  text-decoration: none;
  margin: 0;
  padding: 0 10px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  white-space: nowrap;
  border-width: 1px;
  border-style: solid;
  -moz-border-radius: 0px 0px 0 0;
  -webkit-border-radius: 0px 0px 0 0;
  border-radius: 0px 0px 0 0;
}
#requestDaysOnOffModal .tabs li.tabs-selected a.tabs-inner {
  font-weight: bold;
  outline: none;
}
#requestDaysOnOffModal .tabs li.tabs-selected a:hover.tabs-inner {
  cursor: default;
  pointer: default;
}
#requestDaysOnOffModal .tabs li a.tabs-close,
#requestDaysOnOffModal .tabs-p-tool {
  position: absolute;
  font-size: 1px;
  display: block;
  height: 12px;
  padding: 0;
  top: 50%;
  margin-top: -6px;
  overflow: hidden;
}
#requestDaysOnOffModal .tabs li a.tabs-close {
  width: 12px;
  right: 5px;
  opacity: 0.6;
  filter: alpha(opacity=60);
}
#requestDaysOnOffModal .tabs-p-tool {
  right: 16px;
}
#requestDaysOnOffModal .tabs-p-tool a {
  display: inline-block;
  font-size: 1px;
  width: 12px;
  height: 12px;
  margin: 0;
  opacity: 0.6;
  filter: alpha(opacity=60);
}
#requestDaysOnOffModal .tabs li a:hover.tabs-close,
#requestDaysOnOffModal .tabs-p-tool a:hover {
  opacity: 1;
  filter: alpha(opacity=100);
  cursor: hand;
  cursor: pointer;
}
#requestDaysOnOffModal .tabs-with-icon {
  padding-left: 18px;
}
#requestDaysOnOffModal .tabs-icon {
  position: absolute;
  width: 16px;
  height: 16px;
  left: 10px;
  top: 50%;
  margin-top: -8px;
}
#requestDaysOnOffModal .tabs-title {
  font-size: 12px;
}
#requestDaysOnOffModal .tabs-closable {
  padding-right: 8px;
}
#requestDaysOnOffModal .tabs-panels {
  margin: 0px;
  padding: 0px;
  border-width: 1px;
  border-style: solid;
  border-top-width: 0;
  overflow: hidden;
}
#requestDaysOnOffModal .tabs-header-bottom {
  border-width: 0 1px 1px 1px;
  padding: 0 0 2px 0;
}
#requestDaysOnOffModal .tabs-header-bottom .tabs {
  border-width: 1px 0 0 0;
}
#requestDaysOnOffModal .tabs-header-bottom .tabs li {
  margin: -1px 4px 0 0;
}
#requestDaysOnOffModal .tabs-header-bottom .tabs li a.tabs-inner {
  -moz-border-radius: 0 0 0px 0px;
  -webkit-border-radius: 0 0 0px 0px;
  border-radius: 0 0 0px 0px;
}
#requestDaysOnOffModal .tabs-header-bottom .tabs-tool {
  top: 0;
}
#requestDaysOnOffModal .tabs-header-bottom .tabs-scroller-left,
#requestDaysOnOffModal .tabs-header-bottom .tabs-scroller-right {
  top: 0;
  bottom: auto;
}
#requestDaysOnOffModal .tabs-panels-top {
  border-width: 1px 1px 0 1px;
}
#requestDaysOnOffModal .tabs-header-left {
  float: left;
  border-width: 1px 0 1px 1px;
  padding: 0;
}
#requestDaysOnOffModal .tabs-header-right {
  float: right;
  border-width: 1px 1px 1px 0;
  padding: 0;
}
#requestDaysOnOffModal .tabs-header-left .tabs-wrap,
#requestDaysOnOffModal .tabs-header-right .tabs-wrap {
  height: 100%;
}
#requestDaysOnOffModal .tabs-header-left .tabs {
  height: 100%;
  padding: 4px 0 0 4px;
  border-width: 0 1px 0 0;
}
#requestDaysOnOffModal .tabs-header-right .tabs {
  height: 100%;
  padding: 4px 4px 0 0;
  border-width: 0 0 0 1px;
}
#requestDaysOnOffModal .tabs-header-left .tabs li,
#requestDaysOnOffModal .tabs-header-right .tabs li {
  display: block;
  width: 100%;
  position: relative;
}
#requestDaysOnOffModal .tabs-header-left .tabs li {
  left: auto;
  right: 0;
  margin: 0 -1px 4px 0;
  float: right;
}
#requestDaysOnOffModal .tabs-header-right .tabs li {
  left: 0;
  right: auto;
  margin: 0 0 4px -1px;
  float: left;
}
#requestDaysOnOffModal .tabs-header-left .tabs li a.tabs-inner {
  display: block;
  text-align: left;
  -moz-border-radius: 0px 0 0 0px;
  -webkit-border-radius: 0px 0 0 0px;
  border-radius: 0px 0 0 0px;
}
#requestDaysOnOffModal .tabs-header-right .tabs li a.tabs-inner {
  display: block;
  text-align: left;
  -moz-border-radius: 0 0px 0px 0;
  -webkit-border-radius: 0 0px 0px 0;
  border-radius: 0 0px 0px 0;
}
#requestDaysOnOffModal .tabs-panels-right {
  float: right;
  border-width: 1px 1px 1px 0;
}
#requestDaysOnOffModal .tabs-panels-left {
  float: left;
  border-width: 1px 0 1px 1px;
}
#requestDaysOnOffModal .tabs-header-noborder,
#requestDaysOnOffModal .tabs-panels-noborder {
  border: 0px;
}
#requestDaysOnOffModal .tabs-header-plain {
  border: 0px;
  background: transparent;
}
#requestDaysOnOffModal .tabs-scroller-left {
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat 1px center;
}
#requestDaysOnOffModal .tabs-scroller-right {
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat -15px center;
}
#requestDaysOnOffModal .tabs li a.tabs-close {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat -34px center;
}
#requestDaysOnOffModal .tabs li a.tabs-inner:hover {
  background: #E6E6E6;
  color: #444;
  filter: none;
}
#requestDaysOnOffModal .tabs li.tabs-selected a.tabs-inner {
  background-color: #fff;
  color: #777;
}
#requestDaysOnOffModal .tabs li a.tabs-inner {
  color: #777;
  background-color: #ffffff;
}
#requestDaysOnOffModal .tabs-header,
#requestDaysOnOffModal .tabs-tool {
  background-color: #ffffff;
}
#requestDaysOnOffModal .tabs-header-plain {
  background: transparent;
}
#requestDaysOnOffModal .tabs-header,
#requestDaysOnOffModal .tabs-scroller-left,
#requestDaysOnOffModal .tabs-scroller-right,
#requestDaysOnOffModal .tabs-tool,
#requestDaysOnOffModal .tabs,
#requestDaysOnOffModal .tabs-panels,
#requestDaysOnOffModal .tabs li a.tabs-inner,
#requestDaysOnOffModal .tabs li.tabs-selected a.tabs-inner,
#requestDaysOnOffModal .tabs-header-bottom .tabs li.tabs-selected a.tabs-inner,
#requestDaysOnOffModal .tabs-header-left .tabs li.tabs-selected a.tabs-inner,
#requestDaysOnOffModal .tabs-header-right .tabs li.tabs-selected a.tabs-inner {
  border-color: #ddd;
}
#requestDaysOnOffModal .tabs-p-tool a:hover,
#requestDaysOnOffModal .tabs li a:hover.tabs-close,
#requestDaysOnOffModal .tabs-scroller-over {
  background-color: #E6E6E6;
}
#requestDaysOnOffModal .tabs li.tabs-selected a.tabs-inner {
  border-bottom: 1px solid #fff;
}
#requestDaysOnOffModal .tabs-header-bottom .tabs li.tabs-selected a.tabs-inner {
  border-top: 1px solid #fff;
}
#requestDaysOnOffModal .tabs-header-left .tabs li.tabs-selected a.tabs-inner {
  border-right: 1px solid #fff;
}
#requestDaysOnOffModal .tabs-header-right .tabs li.tabs-selected a.tabs-inner {
  border-left: 1px solid #fff;
}
#requestDaysOnOffModal .l-btn {
  text-decoration: none;
  display: inline-block;
  margin: 0;
  padding: 0;
  cursor: pointer;
  outline: none;
  text-align: center;
  vertical-align: middle;
}
#requestDaysOnOffModal .l-btn-plain {
  border: 0;
  padding: 1px;
}
#requestDaysOnOffModal .l-btn-disabled {
  color: #ccc;
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default;
}
#requestDaysOnOffModal .l-btn-left {
  display: inline-block;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  vertical-align: top;
}
#requestDaysOnOffModal .l-btn-text {
  display: inline-block;
  vertical-align: top;
  width: auto;
  line-height: 24px;
  font-size: 12px;
  padding: 0;
  margin: 0 4px;
}
#requestDaysOnOffModal .l-btn-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  position: absolute;
  top: 50%;
  margin-top: -8px;
  font-size: 1px;
}
#requestDaysOnOffModal .l-btn span span .l-btn-empty {
  display: inline-block;
  margin: 0;
  width: 16px;
  height: 24px;
  font-size: 1px;
  vertical-align: top;
}
#requestDaysOnOffModal .l-btn span .l-btn-icon-left {
  padding: 0 0 0 20px;
  background-position: left center;
}
#requestDaysOnOffModal .l-btn span .l-btn-icon-right {
  padding: 0 20px 0 0;
  background-position: right center;
}
#requestDaysOnOffModal .l-btn-icon-left .l-btn-text {
  margin: 0 4px 0 24px;
}
#requestDaysOnOffModal .l-btn-icon-left .l-btn-icon {
  left: 4px;
}
#requestDaysOnOffModal .l-btn-icon-right .l-btn-text {
  margin: 0 24px 0 4px;
}
#requestDaysOnOffModal .l-btn-icon-right .l-btn-icon {
  right: 4px;
}
#requestDaysOnOffModal .l-btn-icon-top .l-btn-text {
  margin: 20px 4px 0 4px;
}
#requestDaysOnOffModal .l-btn-icon-top .l-btn-icon {
  top: 4px;
  left: 50%;
  margin: 0 0 0 -8px;
}
#requestDaysOnOffModal .l-btn-icon-bottom .l-btn-text {
  margin: 0 4px 20px 4px;
}
#requestDaysOnOffModal .l-btn-icon-bottom .l-btn-icon {
  top: auto;
  bottom: 4px;
  left: 50%;
  margin: 0 0 0 -8px;
}
#requestDaysOnOffModal .l-btn-left .l-btn-empty {
  margin: 0 4px;
  width: 16px;
}
#requestDaysOnOffModal .l-btn-plain:hover {
  padding: 0;
}
#requestDaysOnOffModal .l-btn-focus {
  outline: #0000FF dotted thin;
}
#requestDaysOnOffModal .l-btn-large .l-btn-text {
  line-height: 40px;
}
#requestDaysOnOffModal .l-btn-large .l-btn-icon {
  width: 32px;
  height: 32px;
  line-height: 32px;
  margin-top: -16px;
}
#requestDaysOnOffModal .l-btn-large .l-btn-icon-left .l-btn-text {
  margin-left: 40px;
}
#requestDaysOnOffModal .l-btn-large .l-btn-icon-right .l-btn-text {
  margin-right: 40px;
}
#requestDaysOnOffModal .l-btn-large .l-btn-icon-top .l-btn-text {
  margin-top: 36px;
  line-height: 24px;
  min-width: 32px;
}
#requestDaysOnOffModal .l-btn-large .l-btn-icon-top .l-btn-icon {
  margin: 0 0 0 -16px;
}
#requestDaysOnOffModal .l-btn-large .l-btn-icon-bottom .l-btn-text {
  margin-bottom: 36px;
  line-height: 24px;
  min-width: 32px;
}
#requestDaysOnOffModal .l-btn-large .l-btn-icon-bottom .l-btn-icon {
  margin: 0 0 0 -16px;
}
#requestDaysOnOffModal .l-btn-large .l-btn-left .l-btn-empty {
  margin: 0 4px;
  width: 32px;
}
#requestDaysOnOffModal .l-btn {
  color: #777;
  background: #ffffff;
  background-repeat: repeat-x;
  border: 1px solid #dddddd;
  background: -webkit-linear-gradient(top,#ffffff 0,#ffffff 100%);
  background: -moz-linear-gradient(top,#ffffff 0,#ffffff 100%);
  background: -o-linear-gradient(top,#ffffff 0,#ffffff 100%);
  background: linear-gradient(to bottom,#ffffff 0,#ffffff 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff,endColorstr=#ffffff,GradientType=0);
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .l-btn:hover {
  background: #E6E6E6;
  color: #444;
  border: 1px solid #ddd;
  filter: none;
}
#requestDaysOnOffModal .l-btn-plain {
  background: transparent;
  border: 0;
  filter: none;
}
#requestDaysOnOffModal .l-btn-plain:hover {
  background: #E6E6E6;
  color: #444;
  border: 1px solid #ddd;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .l-btn-disabled,
#requestDaysOnOffModal .l-btn-disabled:hover {
  background: #ffffff;
  color: #777;
  background: -webkit-linear-gradient(top,#ffffff 0,#ffffff 100%);
  background: -moz-linear-gradient(top,#ffffff 0,#ffffff 100%);
  background: -o-linear-gradient(top,#ffffff 0,#ffffff 100%);
  background: linear-gradient(to bottom,#ffffff 0,#ffffff 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff,endColorstr=#ffffff,GradientType=0);
  filter: alpha(opacity=50) progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff,endColorstr=#ffffff,GradientType=0);
}
#requestDaysOnOffModal .l-btn-plain-disabled,
#requestDaysOnOffModal .l-btn-plain-disabled:hover {
  background: transparent;
  filter: alpha(opacity=50);
}
#requestDaysOnOffModal .l-btn-selected,
#requestDaysOnOffModal .l-btn-selected:hover {
  background: #ddd;
  filter: none;
}
#requestDaysOnOffModal .l-btn-plain-selected,
#requestDaysOnOffModal .l-btn-plain-selected:hover {
  background: #ddd;
}
#requestDaysOnOffModal .datagrid .panel-body {
  overflow: hidden;
  position: relative;
}
#requestDaysOnOffModal .datagrid-view {
  position: relative;
  overflow: hidden;
}
#requestDaysOnOffModal .datagrid-view1,
#requestDaysOnOffModal .datagrid-view2 {
  position: absolute;
  overflow: hidden;
  top: 0;
}
#requestDaysOnOffModal .datagrid-view1 {
  left: 0;
}
#requestDaysOnOffModal .datagrid-view2 {
  right: 0;
}
#requestDaysOnOffModal .datagrid-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  filter: alpha(opacity=30);
  display: none;
}
#requestDaysOnOffModal .datagrid-mask-msg {
  position: absolute;
  top: 50%;
  margin-top: -20px;
  padding: 10px 5px 10px 30px;
  width: auto;
  height: 16px;
  border-width: 2px;
  border-style: solid;
  display: none;
}
#requestDaysOnOffModal .datagrid-sort-icon {
  padding: 0;
}
#requestDaysOnOffModal .datagrid-toolbar {
  height: auto;
  padding: 1px 2px;
  border-width: 0 0 1px 0;
  border-style: solid;
}
#requestDaysOnOffModal .datagrid-btn-separator {
  float: left;
  height: 24px;
  border-left: 1px solid #ddd;
  border-right: 1px solid #fff;
  margin: 2px 1px;
}
#requestDaysOnOffModal .datagrid .datagrid-pager {
  display: block;
  margin: 0;
  border-width: 1px 0 0 0;
  border-style: solid;
}
#requestDaysOnOffModal .datagrid .datagrid-pager-top {
  border-width: 0 0 1px 0;
}
#requestDaysOnOffModal .datagrid-header {
  overflow: hidden;
  cursor: default;
  border-width: 0 0 1px 0;
  border-style: solid;
}
#requestDaysOnOffModal .datagrid-header-inner {
  float: left;
  width: 10000px;
}
#requestDaysOnOffModal .datagrid-header-row,
#requestDaysOnOffModal .datagrid-row {
  height: 25px;
}
#requestDaysOnOffModal .datagrid-header td,
#requestDaysOnOffModal .datagrid-body td,
#requestDaysOnOffModal .datagrid-footer td {
  border-width: 0 1px 1px 0;
  border-style: dotted;
  margin: 0;
  padding: 0;
}
#requestDaysOnOffModal .datagrid-cell,
#requestDaysOnOffModal .datagrid-cell-group,
#requestDaysOnOffModal .datagrid-header-rownumber,
#requestDaysOnOffModal .datagrid-cell-rownumber {
  margin: 0;
  padding: 0 4px;
  white-space: nowrap;
  word-wrap: normal;
  overflow: hidden;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
#requestDaysOnOffModal .datagrid-header .datagrid-cell {
  height: auto;
}
#requestDaysOnOffModal .datagrid-header .datagrid-cell span {
  font-size: 12px;
}
#requestDaysOnOffModal .datagrid-cell-group {
  text-align: center;
}
#requestDaysOnOffModal .datagrid-header-rownumber,
#requestDaysOnOffModal .datagrid-cell-rownumber {
  width: 25px;
  text-align: center;
  margin: 0;
  padding: 0;
}
#requestDaysOnOffModal .datagrid-body {
  margin: 0;
  padding: 0;
  overflow: auto;
  zoom: 1;
}
#requestDaysOnOffModal .datagrid-view1 .datagrid-body-inner {
  padding-bottom: 20px;
}
#requestDaysOnOffModal .datagrid-view1 .datagrid-body {
  overflow: hidden;
}
#requestDaysOnOffModal .datagrid-footer {
  overflow: hidden;
}
#requestDaysOnOffModal .datagrid-footer-inner {
  border-width: 1px 0 0 0;
  border-style: solid;
  width: 10000px;
  float: left;
}
#requestDaysOnOffModal .datagrid-row-editing .datagrid-cell {
  height: auto;
}
#requestDaysOnOffModal .datagrid-header-check,
#requestDaysOnOffModal .datagrid-cell-check {
  padding: 0;
  width: 27px;
  height: 18px;
  font-size: 1px;
  text-align: center;
  overflow: hidden;
}
#requestDaysOnOffModal .datagrid-header-check input,
#requestDaysOnOffModal .datagrid-cell-check input {
  margin: 0;
  padding: 0;
  width: 15px;
  height: 18px;
}
#requestDaysOnOffModal .datagrid-resize-proxy {
  position: absolute;
  width: 1px;
  height: 10000px;
  top: 0;
  cursor: e-resize;
  display: none;
}
#requestDaysOnOffModal .datagrid-body .datagrid-editable {
  margin: 0;
  padding: 0;
}
#requestDaysOnOffModal .datagrid-body .datagrid-editable table {
  width: 100%;
  height: 100%;
}
#requestDaysOnOffModal .datagrid-body .datagrid-editable td {
  border: 0;
  margin: 0;
  padding: 0;
}
#requestDaysOnOffModal .datagrid-body .datagrid-editable .datagrid-editable-input {
  margin: 0;
  padding: 2px;
  border-width: 1px;
  border-style: solid;
}
#requestDaysOnOffModal .datagrid-sort-desc .datagrid-sort-icon {
    padding: 0 13px 0 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -31px -31px;
}
#requestDaysOnOffModal .datagrid-sort-asc .datagrid-sort-icon {
    padding: 0 13px 0 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -5px -31px;
}
#requestDaysOnOffModal .datagrid-row-collapse {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -146px -5px;
}
#requestDaysOnOffModal .datagrid-row-expand {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -172px -5px;
}
#requestDaysOnOffModal .datagrid-mask-msg {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat scroll 5px center;
}
#requestDaysOnOffModal .datagrid-header,
#requestDaysOnOffModal .datagrid-td-rownumber {
  background-color: #ffffff;
}
#requestDaysOnOffModal .datagrid-cell-rownumber {
  color: #444;
}
#requestDaysOnOffModal .datagrid-resize-proxy {
  background: #b3b3b3;
}
#requestDaysOnOffModal .datagrid-mask {
  background: #eee;
}
#requestDaysOnOffModal .datagrid-mask-msg {
  border-color: #ddd;
}
#requestDaysOnOffModal .datagrid-toolbar,
#requestDaysOnOffModal .datagrid-pager {
  background: #fff;
}
#requestDaysOnOffModal .datagrid-header,
#requestDaysOnOffModal .datagrid-toolbar,
#requestDaysOnOffModal .datagrid-pager,
#requestDaysOnOffModal .datagrid-footer-inner {
  border-color: #ddd;
}
#requestDaysOnOffModal .datagrid-header td,
#requestDaysOnOffModal .datagrid-body td,
#requestDaysOnOffModal .datagrid-footer td {
  border-color: #ddd;
}
#requestDaysOnOffModal .datagrid-htable,
#requestDaysOnOffModal .datagrid-btable,
#requestDaysOnOffModal .datagrid-ftable {
  color: #444;
  border-collapse: separate;
}
#requestDaysOnOffModal .datagrid-row-alt {
  background: #f5f5f5;
}
#requestDaysOnOffModal .datagrid-row-over,
#requestDaysOnOffModal .datagrid-header td.datagrid-header-over {
  background: #E6E6E6;
  color: #444;
  cursor: default;
}
#requestDaysOnOffModal .datagrid-row-selected {
  background: #CCE6FF;
  color: #000;
}
#requestDaysOnOffModal .datagrid-body .datagrid-editable .datagrid-editable-input {
  border-color: #ddd;
}
#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-body td {
  padding-bottom: 1px;
  border-width: 0 1px 0 0;
}
#requestDaysOnOffModal .propertygrid .datagrid-group {
  height: 21px;
  overflow: hidden;
  border-width: 0 0 1px 0;
  border-style: solid;
}
#requestDaysOnOffModal .propertygrid .datagrid-group span {
  font-weight: bold;
}
#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-body td {
  border-color: #ddd;
}
#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-group {
  border-color: #ffffff;
}
#requestDaysOnOffModal .propertygrid .datagrid-view2 .datagrid-group {
  border-color: #ddd;
}
#requestDaysOnOffModal .propertygrid .datagrid-group,
#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-body,
#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-row-over,
#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-row-selected {
  background: #ffffff;
}
#requestDaysOnOffModal .pagination {
  zoom: 1;
}
#requestDaysOnOffModal .pagination table {
  float: left;
  height: 30px;
}
#requestDaysOnOffModal .pagination td {
  border: 0;
}
#requestDaysOnOffModal .pagination-btn-separator {
  float: left;
  height: 24px;
  border-left: 1px solid #ddd;
  border-right: 1px solid #fff;
  margin: 3px 1px;
}
#requestDaysOnOffModal .pagination .pagination-num {
  border-width: 1px;
  border-style: solid;
  margin: 0 2px;
  padding: 2px;
  width: 2em;
  height: auto;
}
#requestDaysOnOffModal .pagination-page-list {
  margin: 0px 6px;
  padding: 1px 2px;
  width: auto;
  height: auto;
  border-width: 1px;
  border-style: solid;
}
#requestDaysOnOffModal .pagination-info {
  float: right;
  margin: 0 6px 0 0;
  padding: 0;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
#requestDaysOnOffModal .pagination span {
  font-size: 12px;
}
#requestDaysOnOffModal .pagination-link .l-btn-text {
  width: 24px;
  text-align: center;
  margin: 0;
}
#requestDaysOnOffModal .pagination-first {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -157px -125px;
}
#requestDaysOnOffModal .pagination-prev {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -83px -151px;
}
#requestDaysOnOffModal .pagination-next {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -57px -151px;
}
#requestDaysOnOffModal .pagination-last {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -5px -151px;
}
#requestDaysOnOffModal .pagination-load {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -31px -151px;
}
#requestDaysOnOffModal .pagination-loading {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
}
#requestDaysOnOffModal .pagination-page-list,
#requestDaysOnOffModal .pagination .pagination-num {
  border-color: #ddd;
}
#requestDaysOnOffModal .calendar {
  border-width: 1px;
  border-style: solid;
  padding: 1px;
  overflow: hidden;
}
#requestDaysOnOffModal .calendar table {
  table-layout: fixed;
  border-collapse: separate;
  font-size: 12px;
  width: 100%;
  height: 100%;
}
#requestDaysOnOffModal .calendar table td,
#requestDaysOnOffModal .calendar table th {
  font-size: 12px;
}
#requestDaysOnOffModal .calendar-noborder {
  border: 0;
}
#requestDaysOnOffModal .calendar-header {
  position: relative;
  height: 22px;
}
#requestDaysOnOffModal .calendar-title {
  text-align: center;
  height: 22px;
}
#requestDaysOnOffModal .calendar-title span {
  position: relative;
  display: inline-block;
  top: 2px;
  padding: 0 3px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  cursor: pointer;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .calendar-prevmonth,
#requestDaysOnOffModal .calendar-nextmonth,
#requestDaysOnOffModal .calendar-prevyear,
#requestDaysOnOffModal .calendar-nextyear {
  position: absolute;
  top: 50%;
  margin-top: -7px;
  width: 14px;
  height: 14px;
  cursor: pointer;
  font-size: 1px;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .calendar-prevmonth {
  left: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat -18px -2px;
}
#requestDaysOnOffModal .calendar-nextmonth {
  right: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat -34px -2px;
}
#requestDaysOnOffModal .calendar-prevyear {
  left: 3px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat -1px -2px;
}
#requestDaysOnOffModal .calendar-nextyear {
  right: 3px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat -49px -2px;
}
#requestDaysOnOffModal .calendar-body {
  position: relative;
}
#requestDaysOnOffModal .calendar-body th,
#requestDaysOnOffModal .calendar-body td {
  text-align: center;
}
#requestDaysOnOffModal .calendar-day {
  border: 0;
  padding: 1px;
  cursor: pointer;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .calendar-other-month {
  opacity: 0.3;
  filter: alpha(opacity=30);
}
#requestDaysOnOffModal .calendar-disabled {
  opacity: 0.6;
  filter: alpha(opacity=60);
  cursor: default;
}
#requestDaysOnOffModal .calendar-menu {
  position: absolute;
  top: 0;
  left: 0;
  width: 180px;
  height: 150px;
  padding: 5px;
  font-size: 12px;
  display: none;
  overflow: hidden;
}
#requestDaysOnOffModal .calendar-menu-year-inner {
  text-align: center;
  padding-bottom: 5px;
}
#requestDaysOnOffModal .calendar-menu-year {
  width: 40px;
  text-align: center;
  border-width: 1px;
  border-style: solid;
  margin: 0;
  padding: 2px;
  font-weight: bold;
  font-size: 12px;
}
#requestDaysOnOffModal .calendar-menu-prev,
#requestDaysOnOffModal .calendar-menu-next {
  display: inline-block;
  width: 21px;
  height: 21px;
  vertical-align: top;
  cursor: pointer;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .calendar-menu-prev {
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat 2px 2px;
}
#requestDaysOnOffModal .calendar-menu-next {
  margin-left: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat -45px 2px;
}
#requestDaysOnOffModal .calendar-menu-month {
  text-align: center;
  cursor: pointer;
  font-weight: bold;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .calendar-body th,
#requestDaysOnOffModal .calendar-menu-month {
  color: #919191;
}
#requestDaysOnOffModal .calendar-day {
  color: #444;
}
#requestDaysOnOffModal .calendar-sunday {
  color: #CC2222;
}
#requestDaysOnOffModal .calendar-saturday {
  color: #00ee00;
}
#requestDaysOnOffModal .calendar-today {
  color: #0000ff;
}
#requestDaysOnOffModal .calendar-menu-year {
  border-color: #ddd;
}
#requestDaysOnOffModal .calendar {
  border-color: #ddd;
}
#requestDaysOnOffModal .calendar-header {
  background: #ffffff;
}
#requestDaysOnOffModal .calendar-body,
#requestDaysOnOffModal .calendar-menu {
  background: #fff;
}
#requestDaysOnOffModal .calendar-body th {
  background: #fff;
  padding: 2px 0;
}
#requestDaysOnOffModal .calendar-hover,
#requestDaysOnOffModal .calendar-nav-hover,
#requestDaysOnOffModal .calendar-menu-hover {
  background-color: #E6E6E6;
  color: #444;
}
#requestDaysOnOffModal .calendar-hover {
  border: 1px solid #ddd;
  padding: 0;
}
#requestDaysOnOffModal .calendar-selected {
  background-color: #CCE6FF;
  color: #000;
  border: 1px solid #99cdff;
  padding: 0;
}
#requestDaysOnOffModal .datebox-calendar-inner {
  height: 180px;
}
#requestDaysOnOffModal .datebox-button {
  height: 18px;
  padding: 2px 5px;
  text-align: center;
}
#requestDaysOnOffModal .datebox-button a {
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  opacity: 0.6;
  filter: alpha(opacity=60);
}
#requestDaysOnOffModal .datebox-button a:hover {
  opacity: 1.0;
  filter: alpha(opacity=100);
}
#requestDaysOnOffModal .datebox-current,
#requestDaysOnOffModal .datebox-close {
  float: left;
}
#requestDaysOnOffModal .datebox-close {
  float: right;
}
#requestDaysOnOffModal .datebox .combo-arrow {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -57px -31px;
}
#requestDaysOnOffModal .datebox-button {
  background-color: #fff;
}
#requestDaysOnOffModal .datebox-button a {
  color: #777;
}
#requestDaysOnOffModal .numberbox {
  border: 1px solid #ddd;
  margin: 0;
  padding: 0 2px;
  vertical-align: middle;
}
#requestDaysOnOffModal .spinner {
  display: inline-block;
  white-space: nowrap;
  margin: 0;
  padding: 0;
  border-width: 1px;
  border-style: solid;
  overflow: hidden;
  vertical-align: middle;
}
#requestDaysOnOffModal .spinner .spinner-text {
  font-size: 12px;
  border: 0px;
  line-height: 20px;
  height: 20px;
  margin: 0;
  padding: 0 2px;
  *margin-top: -1px;
  *height: 18px;
  *line-height: 18px;
  _height: 18px;
  _line-height: 18px;
  vertical-align: baseline;
}
#requestDaysOnOffModal .spinner-arrow {
  display: inline-block;
  overflow: hidden;
  vertical-align: top;
  margin: 0;
  padding: 0;
}
#requestDaysOnOffModal .spinner-arrow-up,
#requestDaysOnOffModal .spinner-arrow-down {
  opacity: 0.6;
  filter: alpha(opacity=60);
  display: block;
  font-size: 1px;
  width: 18px;
  height: 10px;
}
#requestDaysOnOffModal .spinner-arrow-hover {
  opacity: 1.0;
  filter: alpha(opacity=100);
}
#requestDaysOnOffModal .spinner-arrow-up {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -191px -109px;
}
#requestDaysOnOffModal .spinner-arrow-down {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -203px -83px;
}
#requestDaysOnOffModal .spinner {
  border-color: #ddd;
}
#requestDaysOnOffModal .spinner-arrow {
  background-color: #ffffff;
}
#requestDaysOnOffModal .spinner-arrow-hover {
  background-color: #E6E6E6;
}
#requestDaysOnOffModal .progressbar {
  border-width: 1px;
  border-style: solid;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
  overflow: hidden;
  position: relative;
}
#requestDaysOnOffModal .progressbar-text {
  text-align: center;
  position: absolute;
}
#requestDaysOnOffModal .progressbar-value {
  position: relative;
  overflow: hidden;
  width: 0;
  -moz-border-radius: 0px 0 0 0px;
  -webkit-border-radius: 0px 0 0 0px;
  border-radius: 0px 0 0 0px;
}
#requestDaysOnOffModal .progressbar {
  border-color: #ddd;
}
#requestDaysOnOffModal .progressbar-text {
  color: #444;
  font-size: 12px;
}
#requestDaysOnOffModal .progressbar-value .progressbar-text {
  background-color: #CCE6FF;
  color: #000;
}
#requestDaysOnOffModal .searchbox {
  display: inline-block;
  white-space: nowrap;
  margin: 0;
  padding: 0;
  border-width: 1px;
  border-style: solid;
  overflow: hidden;
  vertical-align: middle;
}
#requestDaysOnOffModal .searchbox .searchbox-text {
  font-size: 12px;
  border: 0;
  margin: 0;
  padding: 0 2px;
  *margin-top: -1px;
  vertical-align: top;
}
#requestDaysOnOffModal .searchbox .searchbox-prompt {
  font-size: 12px;
  color: #ccc;
}
#requestDaysOnOffModal .searchbox-button {
  width: 18px;
  height: 20px;
  overflow: hidden;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  opacity: 0.6;
  filter: alpha(opacity=60);
}
#requestDaysOnOffModal .searchbox-button-hover {
  opacity: 1.0;
  filter: alpha(opacity=100);
}
#requestDaysOnOffModal .searchbox .l-btn-plain {
  border: 0;
  padding: 0;
  vertical-align: top;
  opacity: 0.6;
  filter: alpha(opacity=60);
  -moz-border-radius: 0 0 0 0;
  -webkit-border-radius: 0 0 0 0;
  border-radius: 0 0 0 0;
}
#requestDaysOnOffModal .searchbox .l-btn-plain:hover {
  border: 0;
  padding: 0;
  opacity: 1.0;
  filter: alpha(opacity=100);
  -moz-border-radius: 0 0 0 0;
  -webkit-border-radius: 0 0 0 0;
  border-radius: 0 0 0 0;
}
#requestDaysOnOffModal .searchbox a.m-btn-plain-active {
  -moz-border-radius: 0 0 0 0;
  -webkit-border-radius: 0 0 0 0;
  border-radius: 0 0 0 0;
}
#requestDaysOnOffModal .searchbox-button {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -203px -57px;
}
#requestDaysOnOffModal .searchbox {
  border-color: #ddd;
  background-color: #fff;
}
#requestDaysOnOffModal .searchbox .l-btn-plain {
  background: #ffffff;
}
#requestDaysOnOffModal .searchbox .l-btn-plain-disabled,
#requestDaysOnOffModal .searchbox .l-btn-plain-disabled:hover {
  opacity: 0.5;
  filter: alpha(opacity=50);
}
#requestDaysOnOffModal .slider-disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
}
#requestDaysOnOffModal .slider-h {
  height: 22px;
}
#requestDaysOnOffModal .slider-v {
  width: 22px;
}
#requestDaysOnOffModal .slider-inner {
  position: relative;
  height: 6px;
  top: 7px;
  border-width: 1px;
  border-style: solid;
  border-radius: 0px;
}
#requestDaysOnOffModal .slider-handle {
  position: absolute;
  display: block;
  outline: none;
  width: 20px;
  height: 20px;
  top: -7px;
  margin-left: -10px;
}
#requestDaysOnOffModal .slider-tip {
  position: absolute;
  display: inline-block;
  line-height: 12px;
  font-size: 12px;
  white-space: nowrap;
  top: -22px;
}
#requestDaysOnOffModal .slider-rule {
  position: relative;
  top: 15px;
}
#requestDaysOnOffModal .slider-rule span {
  position: absolute;
  display: inline-block;
  font-size: 0;
  height: 5px;
  border-width: 0 0 0 1px;
  border-style: solid;
}
#requestDaysOnOffModal .slider-rulelabel {
  position: relative;
  top: 20px;
}
#requestDaysOnOffModal .slider-rulelabel span {
  position: absolute;
  display: inline-block;
  font-size: 12px;
}
#requestDaysOnOffModal .slider-v .slider-inner {
  width: 6px;
  left: 7px;
  top: 0;
  float: left;
}
#requestDaysOnOffModal .slider-v .slider-handle {
  left: 3px;
  margin-top: -10px;
}
#requestDaysOnOffModal .slider-v .slider-tip {
  left: -10px;
  margin-top: -6px;
}
#requestDaysOnOffModal .slider-v .slider-rule {
  float: left;
  top: 0;
  left: 16px;
}
#requestDaysOnOffModal .slider-v .slider-rule span {
  width: 5px;
  height: 'auto';
  border-left: 0;
  border-width: 1px 0 0 0;
  border-style: solid;
}
#requestDaysOnOffModal .slider-v .slider-rulelabel {
  float: left;
  top: 0;
  left: 23px;
}
#requestDaysOnOffModal .slider-handle {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat;
}
#requestDaysOnOffModal .slider-inner {
  border-color: #ddd;
  background: #ffffff;
}
#requestDaysOnOffModal .slider-rule span {
  border-color: #ddd;
}
#requestDaysOnOffModal .slider-rulelabel span {
  color: #444;
}
#requestDaysOnOffModal .menu {
  position: absolute;
  margin: 0;
  padding: 2px;
  border-width: 1px;
  border-style: solid;
  overflow: hidden;
}
#requestDaysOnOffModal .menu-item {
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  border-width: 1px;
  border-style: solid;
}
#requestDaysOnOffModal .menu-text {
  height: 20px;
  line-height: 20px;
  float: left;
  padding-left: 28px;
}
#requestDaysOnOffModal .menu-icon {
  position: absolute;
  width: 16px;
  height: 16px;
  left: 2px;
  top: 50%;
  margin-top: -8px;
}
#requestDaysOnOffModal .menu-rightarrow {
  position: absolute;
  width: 16px;
  height: 16px;
  right: 0;
  top: 50%;
  margin-top: -8px;
}
#requestDaysOnOffModal .menu-line {
  position: absolute;
  left: 26px;
  top: 0;
  height: 2000px;
  font-size: 1px;
}
#requestDaysOnOffModal .menu-sep {
  margin: 3px 0px 3px 25px;
  font-size: 1px;
}
#requestDaysOnOffModal .menu-active {
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .menu-item-disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default;
}
#requestDaysOnOffModal .menu-text,
#requestDaysOnOffModal .menu-text span {
  font-size: 12px;
}
#requestDaysOnOffModal .menu-shadow {
  position: absolute;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
  background: #eee;
  -moz-box-shadow: 2px 2px 3px #ededed;
  -webkit-box-shadow: 2px 2px 3px #ededed;
  box-shadow: 2px 2px 3px #ededed;
  filter: progid:DXImageTransform.Microsoft.Blur(pixelRadius=2,MakeShadow=false,ShadowOpacity=0.2);
}
#requestDaysOnOffModal .menu-rightarrow {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -57px -57px;
}
#requestDaysOnOffModal .menu-line {
  border-left: 1px solid #ddd;
  border-right: 1px solid #fff;
}
#requestDaysOnOffModal .menu-sep {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #fff;
}
#requestDaysOnOffModal .menu {
  background-color: #ffffff;
  border-color: #ddd;
  color: #444;
}
#requestDaysOnOffModal .menu-content {
  background: #fff;
}
#requestDaysOnOffModal .menu-item {
  border-color: transparent;
  _border-color: #ffffff;
}
#requestDaysOnOffModal .menu-active {
  border-color: #ddd;
  color: #444;
  background: #E6E6E6;
}
#requestDaysOnOffModal .menu-active-disabled {
  border-color: transparent;
  background: transparent;
  color: #444;
}
#requestDaysOnOffModal .m-btn-downarrow,
#requestDaysOnOffModal .s-btn-downarrow {
  display: inline-block;
  position: absolute;
  width: 16px;
  height: 16px;
  font-size: 1px;
  right: 0;
  top: 50%;
  margin-top: -8px;
}
#requestDaysOnOffModal .m-btn-active,
#requestDaysOnOffModal .s-btn-active {
  background: #E6E6E6;
  color: #444;
  border: 1px solid #ddd;
  filter: none;
}
#requestDaysOnOffModal .m-btn-plain-active,
#requestDaysOnOffModal .s-btn-plain-active {
  background: transparent;
  padding: 0;
  border-width: 1px;
  border-style: solid;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .m-btn .l-btn-left .l-btn-text {
  margin-right: 20px;
}
#requestDaysOnOffModal .m-btn .l-btn-icon-right .l-btn-text {
  margin-right: 40px;
}
#requestDaysOnOffModal .m-btn .l-btn-icon-right .l-btn-icon {
  right: 20px;
}
#requestDaysOnOffModal .m-btn .l-btn-icon-top .l-btn-text {
  margin-right: 4px;
  margin-bottom: 14px;
}
#requestDaysOnOffModal .m-btn .l-btn-icon-bottom .l-btn-text {
  margin-right: 4px;
  margin-bottom: 34px;
}
#requestDaysOnOffModal .m-btn .l-btn-icon-bottom .l-btn-icon {
  top: auto;
  bottom: 20px;
}
#requestDaysOnOffModal .m-btn .l-btn-icon-top .m-btn-downarrow,
#requestDaysOnOffModal .m-btn .l-btn-icon-bottom .m-btn-downarrow {
  top: auto;
  bottom: 0px;
  left: 50%;
  margin-left: -8px;
}
#requestDaysOnOffModal .m-btn-line {
  display: inline-block;
  position: absolute;
  font-size: 1px;
  display: none;
}
#requestDaysOnOffModal .m-btn .l-btn-left .m-btn-line {
  right: 0;
  width: 16px;
  height: 500px;
  border-style: solid;
  border-color: #b3b3b3;
  border-width: 0 0 0 1px;
}
#requestDaysOnOffModal .m-btn .l-btn-icon-top .m-btn-line,
#requestDaysOnOffModal .m-btn .l-btn-icon-bottom .m-btn-line {
  left: 0;
  bottom: 0;
  width: 500px;
  height: 16px;
  border-width: 1px 0 0 0;
}
#requestDaysOnOffModal .m-btn-large .l-btn-icon-right .l-btn-text {
  margin-right: 56px;
}
#requestDaysOnOffModal .m-btn-large .l-btn-icon-bottom .l-btn-text {
  margin-bottom: 50px;
}
#requestDaysOnOffModal .m-btn-downarrow,
#requestDaysOnOffModal .s-btn-downarrow {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -83px -57px;
}
#requestDaysOnOffModal .m-btn-plain-active,
#requestDaysOnOffModal .s-btn-plain-active {
  border-color: #ddd;
  background-color: #E6E6E6;
  color: #444;
}
#requestDaysOnOffModal .s-btn:hover .m-btn-line,
#requestDaysOnOffModal .s-btn-active .m-btn-line,
#requestDaysOnOffModal .s-btn-plain-active .m-btn-line {
  display: inline-block;
}
#requestDaysOnOffModal .l-btn:hover .s-btn-downarrow,
#requestDaysOnOffModal .s-btn-active .s-btn-downarrow,
#requestDaysOnOffModal .s-btn-plain-active .s-btn-downarrow {
  border-style: solid;
  border-color: #b3b3b3;
  border-width: 0 0 0 1px;
}
#requestDaysOnOffModal .messager-body {
  padding: 10px;
  overflow: hidden;
}
#requestDaysOnOffModal .messager-button {
  text-align: center;
  padding-top: 10px;
}
#requestDaysOnOffModal .messager-button .l-btn {
  width: 70px;
}
#requestDaysOnOffModal .messager-icon {
  float: left;
  width: 32px;
  height: 32px;
  margin: 0 10px 10px 0;
}
#requestDaysOnOffModal .messager-error {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -161px -57px;
}
#requestDaysOnOffModal .messager-info {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -5px -99px;
}
#requestDaysOnOffModal .messager-question {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -47px -99px;
}
#requestDaysOnOffModal .messager-warning {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat -89px -99px;
}
#requestDaysOnOffModal .messager-progress {
  padding: 10px;
}
#requestDaysOnOffModal .messager-p-msg {
  margin-bottom: 5px;
}
#requestDaysOnOffModal .messager-body .messager-input {
  width: 100%;
  padding: 1px 0;
  border: 1px solid #ddd;
}
#requestDaysOnOffModal .tree {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
#requestDaysOnOffModal .tree li {
  white-space: nowrap;
}
#requestDaysOnOffModal .tree li ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
#requestDaysOnOffModal .tree-node {
  height: 18px;
  white-space: nowrap;
  cursor: pointer;
}
#requestDaysOnOffModal .tree-hit {
  cursor: pointer;
}
#requestDaysOnOffModal .tree-expanded,
#requestDaysOnOffModal .tree-collapsed,
#requestDaysOnOffModal .tree-folder,
#requestDaysOnOffModal .tree-file,
#requestDaysOnOffModal .tree-checkbox,
#requestDaysOnOffModal .tree-indent {
  display: inline-block;
  width: 16px;
  height: 18px;
  vertical-align: top;
  overflow: hidden;
}
#requestDaysOnOffModal .tree-expanded {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -18px 0px;
}
#requestDaysOnOffModal .tree-expanded-hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -50px 0px;
}
#requestDaysOnOffModal .tree-collapsed {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat 0px 0px;
}
#requestDaysOnOffModal .tree-collapsed-hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -32px 0px;
}
#requestDaysOnOffModal .tree-lines .tree-expanded,
#requestDaysOnOffModal .tree-lines .tree-root-first .tree-expanded {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -144px 0;
}
#requestDaysOnOffModal .tree-lines .tree-collapsed,
#requestDaysOnOffModal .tree-lines .tree-root-first .tree-collapsed {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -128px 0;
}
#requestDaysOnOffModal .tree-lines .tree-node-last .tree-expanded,
#requestDaysOnOffModal .tree-lines .tree-root-one .tree-expanded {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -80px 0;
}
#requestDaysOnOffModal .tree-lines .tree-node-last .tree-collapsed,
#requestDaysOnOffModal .tree-lines .tree-root-one .tree-collapsed {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -64px 0;
}
#requestDaysOnOffModal .tree-line {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -176px 0;
}
#requestDaysOnOffModal .tree-join {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -192px 0;
}
#requestDaysOnOffModal .tree-joinbottom {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -160px 0;
}
#requestDaysOnOffModal .tree-folder {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -208px 0;
}
#requestDaysOnOffModal .tree-folder-open {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -224px 0;
}
#requestDaysOnOffModal .tree-file {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -240px 0;
}
#requestDaysOnOffModal .tree-loading {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
}
#requestDaysOnOffModal .tree-checkbox0 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -208px -18px;
}
#requestDaysOnOffModal .tree-checkbox1 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -224px -18px;
}
#requestDaysOnOffModal .tree-checkbox2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -240px -18px;
}
#requestDaysOnOffModal .tree-title {
  font-size: 12px;
  display: inline-block;
  text-decoration: none;
  vertical-align: top;
  white-space: nowrap;
  padding: 0 2px;
  height: 18px;
  line-height: 18px;
}
#requestDaysOnOffModal .tree-node-proxy {
  font-size: 12px;
  line-height: 20px;
  padding: 0 2px 0 20px;
  border-width: 1px;
  border-style: solid;
  z-index: 9900000;
}
#requestDaysOnOffModal .tree-dnd-icon {
  display: inline-block;
  position: absolute;
  width: 16px;
  height: 18px;
  left: 2px;
  top: 50%;
  margin-top: -9px;
}
#requestDaysOnOffModal .tree-dnd-yes {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -256px 0;
}
#requestDaysOnOffModal .tree-dnd-no {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -256px -18px;
}
#requestDaysOnOffModal /*.tree-node-top {
  border-top: 1px dotted red;
}
.tree-node-bottom {
  border-bottom: 1px dotted red;
}*/
#requestDaysOnOffModal .tree-node-append .tree-title {
  border: 1px dotted red;
}
#requestDaysOnOffModal .tree-editor {
  border: 1px solid #ccc;
  font-size: 12px;
  height: 14px !important;
  height: 18px;
  line-height: 14px;
  padding: 1px 2px;
  width: 80px;
  position: absolute;
  top: 0;
}
#requestDaysOnOffModal .tree-node-proxy {
  background-color: #fff;
  color: #444;
  border-color: #ddd;
}
#requestDaysOnOffModal .tree-node-hover {
  background: #E6E6E6;
  color: #444;
}
#requestDaysOnOffModal .tree-node-selected {
  background: #CCE6FF;
  color: #000;
}
#requestDaysOnOffModal .validatebox-invalid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right center;
  border-color: #ffa8a8;
  background-color: #fff3f3;
  color: #000;
}
#requestDaysOnOffModal .tooltip {
  position: absolute;
  display: none;
  z-index: 9900000;
  outline: none;
  opacity: 1;
  filter: alpha(opacity=100);
  padding: 5px;
  border-width: 1px;
  border-style: solid;
  border-radius: 5px;
  -moz-border-radius: 0px 0px 0px 0px;
  -webkit-border-radius: 0px 0px 0px 0px;
  border-radius: 0px 0px 0px 0px;
}
#requestDaysOnOffModal .tooltip-content {
  font-size: 12px;
}
#requestDaysOnOffModal .tooltip-arrow-outer,
#requestDaysOnOffModal .tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  line-height: 0;
  font-size: 0;
  border-style: solid;
  border-width: 6px;
  border-color: transparent;
  _border-color: tomato;
  _filter: chroma(color=tomato);
}
#requestDaysOnOffModal .tooltip-right .tooltip-arrow-outer {
  left: 0;
  top: 50%;
  margin: -6px 0 0 -13px;
}
#requestDaysOnOffModal .tooltip-right .tooltip-arrow {
  left: 0;
  top: 50%;
  margin: -6px 0 0 -12px;
}
#requestDaysOnOffModal .tooltip-left .tooltip-arrow-outer {
  right: 0;
  top: 50%;
  margin: -6px -13px 0 0;
}
#requestDaysOnOffModal .tooltip-left .tooltip-arrow {
  right: 0;
  top: 50%;
  margin: -6px -12px 0 0;
}
#requestDaysOnOffModal .tooltip-top .tooltip-arrow-outer {
  bottom: 0;
  left: 50%;
  margin: 0 0 -13px -6px;
}
#requestDaysOnOffModal .tooltip-top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin: 0 0 -12px -6px;
}
#requestDaysOnOffModal .tooltip-bottom .tooltip-arrow-outer {
  top: 0;
  left: 50%;
  margin: -13px 0 0 -6px;
}
#requestDaysOnOffModal .tooltip-bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin: -12px 0 0 -6px;
}
#requestDaysOnOffModal .tooltip {
  background-color: #fff;
  border-color: #ddd;
  color: #444;
}
#requestDaysOnOffModal .tooltip-right .tooltip-arrow-outer {
  border-right-color: #ddd;
}
#requestDaysOnOffModal .tooltip-right .tooltip-arrow {
  border-right-color: #fff;
}
#requestDaysOnOffModal .tooltip-left .tooltip-arrow-outer {
  border-left-color: #ddd;
}
#requestDaysOnOffModal .tooltip-left .tooltip-arrow {
  border-left-color: #fff;
}
#requestDaysOnOffModal .tooltip-top .tooltip-arrow-outer {
  border-top-color: #ddd;
}
#requestDaysOnOffModal .tooltip-top .tooltip-arrow {
  border-top-color: #fff;
}
#requestDaysOnOffModal .tooltip-bottom .tooltip-arrow-outer {
  border-bottom-color: #ddd;
}
#requestDaysOnOffModal .tooltip-bottom .tooltip-arrow {
  border-bottom-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./wwwroot/Scripts/EasyUI/themes/default/easyui.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,6DAA6C;AAC/C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;EACzB,uCAAuC;EACvC,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,uEAAyD;AAC3D;AACA;IACI,2EAA0D;AAC9D;AACA;IACI,0EAAyD;AAC7D;AACA;IACI,yEAAwD;AAC5D;AACA;IACI,0EAAyD;AAC7D;AACA;IACI,2EAA0D;AAC9D;AACA;IACI,2EAA0D;AAC9D;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;IACI,yEAAwD;AAC5D;AACA;IACI,0EAAyD;AAC7D;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,cAAc;GACd,OAAQ;EACR,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B;EAC/B,gGAAgG;AAClG;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,gBAAgB;GAChB,gBAAiB;GACjB,YAAa;GACb,iBAAkB;GAClB,YAAa;GACb,iBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;IACI,wEAAuD;AAC3D;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;AACZ;AACA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,UAAU;AACZ;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,UAAU;AACZ;AACA;IACI,yEAAwD;AAC5D;AACA;IACI,0EAAyD;AAC7D;AACA;IACI,0EAAyD;AAC7D;AACA;IACI,wEAAuD;AAC3D;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,cAAc;EACd,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,yBAAyB;AAC3B;AACA;;EAEE,UAAU;EACV,0BAA0B;EAC1B,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,MAAM;AACR;AACA;;EAEE,MAAM;EACN,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,UAAU;AACZ;AACA;;EAEE,YAAY;AACd;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;AACzB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,QAAQ;EACR,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,2BAA2B;AAC7B;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,gFAAqE;AACvE;AACA;EACE,kFAAuE;AACzE;AACA;EACE,0EAA+D;AACjE;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;;;;;;;;;;;EAWE,kBAAkB;AACpB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;AACX;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,+DAA+D;EAC/D,4DAA4D;EAC5D,0DAA0D;EAC1D,6DAA6D;EAC7D,2BAA2B;EAC3B,4GAA4G;EAC5G,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,+DAA+D;EAC/D,4DAA4D;EAC5D,0DAA0D;EAC1D,6DAA6D;EAC7D,2BAA2B;EAC3B,4GAA4G;EAC5G,8HAA8H;AAChI;AACA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;AACR;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;;EAEE,YAAY;AACd;AACA;;;EAGE,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;AACA;;;;EAIE,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,OAAO;AACT;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;;EAEE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,MAAM;EACN,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,SAAS;EACT,UAAU;AACZ;AACA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;IACI,mBAAmB;IACnB,yEAAwD;AAC5D;AACA;IACI,mBAAmB;IACnB,wEAAuD;AAC3D;AACA;IACI,yEAAwD;AAC5D;AACA;IACI,yEAAwD;AAC5D;AACA;EACE,oFAAsE;AACxE;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;AACA;IACI,2EAA0D;AAC9D;AACA;IACI,0EAAyD;AAC7D;AACA;IACI,0EAAyD;AAC7D;AACA;IACI,yEAAwD;AAC5D;AACA;IACI,0EAAyD;AAC7D;AACA;EACE,2EAA6D;AAC/D;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;;EAEE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,wEAAkE;AACpE;AACA;EACE,WAAW;EACX,wEAAkE;AACpE;AACA;EACE,SAAS;EACT,uEAAiE;AACnE;AACA;EACE,UAAU;EACV,wEAAkE;AACpE;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,qEAA+D;AACjE;AACA;EACE,iBAAiB;EACjB,uEAAiE;AACnE;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;;EAEE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;IACI,yEAAwD;AAC5D;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,cAAc;GACd,gBAAiB;GACjB,YAAa;GACb,iBAAkB;GAClB,YAAa;GACb,iBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;IACI,2EAA0D;AAC9D;AACA;IACI,0EAAyD;AAC7D;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,cAAc;GACd,gBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;IACI,0EAAyD;AAC7D;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,UAAU;EACV,SAAS;EACT,MAAM;EACN,WAAW;AACb;AACA;EACE,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,MAAM;EACN,UAAU;AACZ;AACA;EACE,UAAU;EACV,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,MAAM;EACN,UAAU;AACZ;AACA;EACE,6DAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,cAAc;EACd,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;EAC9B,gBAAgB;EAChB,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B;EAC/B,gGAAgG;AAClG;AACA;IACI,yEAAwD;AAC5D;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;GACzB,qBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,QAAQ;EACR,QAAQ;EACR,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;AACA;;EAEE,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;;EAEE,SAAS;EACT,WAAW;EACX,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;AACA;EACE,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,OAAO;EACP,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;IAEI,yEAAwD;AAC5D;AACA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;IACI,0EAAyD;AAC7D;AACA;IACI,wEAAuD;AAC3D;AACA;IACI,yEAAwD;AAC5D;AACA;IACI,yEAAwD;AAC5D;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;;;;;EAME,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,uEAA4D;AAC9D;AACA;EACE,uEAA4D;AAC9D;AACA;EACE,qEAA0D;AAC5D;AACA;EACE,uEAA4D;AAC9D;AACA;;EAEE,sEAA2D;AAC7D;AACA;;EAEE,sEAA2D;AAC7D;AACA;;EAEE,qEAA0D;AAC5D;AACA;;EAEE,qEAA0D;AAC5D;AACA;EACE,sEAA2D;AAC7D;AACA;EACE,sEAA2D;AAC7D;AACA;EACE,sEAA2D;AAC7D;AACA;EACE,sEAA2D;AAC7D;AACA;EACE,sEAA2D;AAC7D;AACA;EACE,sEAA2D;AAC7D;AACA;EACE,2EAA6D;AAC/D;AACA;EACE,0EAA+D;AACjE;AACA;EACE,0EAA+D;AACjE;AACA;EACE,0EAA+D;AACjE;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,sEAA2D;AAC7D;AACA;EACE,0EAA+D;AACjE;AACA;;;;;;;EAOE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yDAAuD;EACvD,4BAA4B;EAC5B,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;GACzB,oBAAqB;GACrB,4BAA6B;AAC/B;AACA;EACE,OAAO;EACP,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,OAAO;EACP,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,QAAQ;EACR,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,QAAQ;EACR,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,MAAM;EACN,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,MAAM;EACN,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["#requestDaysOnOffModal .panel {\r\n  overflow: hidden;\r\n  text-align: left;\r\n  margin: 0;\r\n  border: 0;\r\n  -moz-border-radius: 0 0 0 0;\r\n  -webkit-border-radius: 0 0 0 0;\r\n  border-radius: 0 0 0 0;\r\n}\r\n#requestDaysOnOffModal .panel-header,\r\n#requestDaysOnOffModal .panel-body {\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .panel-header {\r\n  padding: 5px;\r\n  position: relative;\r\n}\r\n#requestDaysOnOffModal .panel-title {\r\n  background: url('images/blank.gif') no-repeat;\r\n}\r\n#requestDaysOnOffModal .panel-header-noborder {\r\n  border-width: 0 0 1px 0;\r\n}\r\n#requestDaysOnOffModal .panel-body {\r\n  overflow: auto;\r\n  border-top-width: 0;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .panel-body-noheader {\r\n  border-top-width: 1px;\r\n}\r\n#requestDaysOnOffModal .panel-body-noborder {\r\n  border-width: 0px;\r\n}\r\n#requestDaysOnOffModal .panel-with-icon {\r\n  padding-left: 18px;\r\n}\r\n#requestDaysOnOffModal .panel-icon,\r\n#requestDaysOnOffModal .panel-tool {\r\n  position: absolute;\r\n  top: 50%;\r\n  margin-top: -8px;\r\n  height: 16px;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .panel-icon {\r\n  left: 5px;\r\n  width: 16px;\r\n}\r\n#requestDaysOnOffModal .panel-tool {\r\n  right: 5px;\r\n  width: auto;\r\n}\r\n#requestDaysOnOffModal .panel-tool a {\r\n  display: inline-block;\r\n  width: 16px;\r\n  height: 16px;\r\n  opacity: 0.6;\r\n  filter: alpha(opacity=60);\r\n  margin: 0 0 0 2px;\r\n  vertical-align: top;\r\n}\r\n#requestDaysOnOffModal .panel-tool a:hover {\r\n  opacity: 1;\r\n  filter: alpha(opacity=100);\r\n  background-color: #E6E6E6;\r\n  -moz-border-radius: -2px -2px -2px -2px;\r\n  -webkit-border-radius: -2px -2px -2px -2px;\r\n  border-radius: -2px -2px -2px -2px;\r\n}\r\n#requestDaysOnOffModal .panel-loading {\r\n  padding: 11px 0px 10px 30px;\r\n}\r\n#requestDaysOnOffModal .panel-noscroll {\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .panel-fit,\r\n#requestDaysOnOffModal .panel-fit body {\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: 0;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .panel-loading {\r\n  background: url('images/loading.gif') no-repeat 10px 10px;\r\n}\r\n#requestDaysOnOffModal .panel-tool-close {\r\n    background: url('spritesheet.png') no-repeat -109px -151px;\r\n}\r\n#requestDaysOnOffModal .panel-tool-min {\r\n    background: url('spritesheet.png') no-repeat -31px -177px;\r\n}\r\n#requestDaysOnOffModal .panel-tool-max {\r\n    background: url('spritesheet.png') no-repeat -5px -177px;\r\n}\r\n#requestDaysOnOffModal .panel-tool-restore {\r\n    background: url('spritesheet.png') no-repeat -57px -177px;\r\n}\r\n#requestDaysOnOffModal .panel-tool-collapse {\r\n    background: url('spritesheet.png') no-repeat -135px -151px;\r\n}\r\n#requestDaysOnOffModal .panel-tool-expand {\r\n    background: url('spritesheet.png') no-repeat -161px -151px;\r\n}\r\n#requestDaysOnOffModal .panel-header,\r\n#requestDaysOnOffModal .panel-body {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .panel-header {\r\n  background-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .panel-body {\r\n  background-color: #fff;\r\n  color: #444;\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .panel-title {\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  color: #777;\r\n  height: 16px;\r\n  line-height: 16px;\r\n}\r\n#requestDaysOnOffModal .accordion {\r\n  overflow: hidden;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .accordion .accordion-header {\r\n  border-width: 0 0 1px;\r\n  cursor: pointer;\r\n}\r\n#requestDaysOnOffModal .accordion .accordion-body {\r\n  border-width: 0 0 1px;\r\n}\r\n#requestDaysOnOffModal .accordion-noborder {\r\n  border-width: 0;\r\n}\r\n#requestDaysOnOffModal .accordion-noborder .accordion-header {\r\n  border-width: 0 0 1px;\r\n}\r\n#requestDaysOnOffModal .accordion-noborder .accordion-body {\r\n  border-width: 0 0 1px;\r\n}\r\n#requestDaysOnOffModal .accordion-collapse {\r\n    background: url('spritesheet.png') no-repeat -31px -57px;\r\n}\r\n#requestDaysOnOffModal .accordion-expand {\r\n    background: url('spritesheet.png') no-repeat -135px -31px;\r\n}\r\n#requestDaysOnOffModal .accordion {\r\n  background: #fff;\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .accordion .accordion-header {\r\n  background: #ffffff;\r\n  filter: none;\r\n}\r\n#requestDaysOnOffModal .accordion .accordion-header-selected {\r\n  background: #CCE6FF;\r\n}\r\n#requestDaysOnOffModal .accordion .accordion-header-selected .panel-title {\r\n  color: #000;\r\n}\r\n#requestDaysOnOffModal .window {\r\n  overflow: hidden;\r\n  padding: 5px;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .window .window-header {\r\n  background: transparent;\r\n  padding: 0px 0px 6px 0px;\r\n}\r\n#requestDaysOnOffModal .window .window-body {\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-top-width: 0px;\r\n}\r\n#requestDaysOnOffModal .window .window-body-noheader {\r\n  border-top-width: 1px;\r\n}\r\n#requestDaysOnOffModal .window .window-header .panel-icon,\r\n#requestDaysOnOffModal .window .window-header .panel-tool {\r\n  top: 50%;\r\n  margin-top: -11px;\r\n}\r\n#requestDaysOnOffModal .window .window-header .panel-icon {\r\n  left: 1px;\r\n}\r\n#requestDaysOnOffModal .window .window-header .panel-tool {\r\n  right: 1px;\r\n}\r\n#requestDaysOnOffModal .window .window-header .panel-with-icon {\r\n  padding-left: 18px;\r\n}\r\n#requestDaysOnOffModal .window-proxy {\r\n  position: absolute;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .window-proxy-mask {\r\n  position: absolute;\r\n  filter: alpha(opacity=5);\r\n  opacity: 0.05;\r\n}\r\n#requestDaysOnOffModal .window-mask {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  filter: alpha(opacity=40);\r\n  opacity: 0.40;\r\n  font-size: 1px;\r\n  *zoom: 1;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .window,\r\n#requestDaysOnOffModal .window-shadow {\r\n  position: absolute;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .window-shadow {\r\n  background: #eee;\r\n  -moz-box-shadow: 2px 2px 3px #ededed;\r\n  -webkit-box-shadow: 2px 2px 3px #ededed;\r\n  box-shadow: 2px 2px 3px #ededed;\r\n  filter: progid:DXImageTransform.Microsoft.Blur(pixelRadius=2,MakeShadow=false,ShadowOpacity=0.2);\r\n}\r\n#requestDaysOnOffModal .window,\r\n#requestDaysOnOffModal .window .window-body {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .window {\r\n  background-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .window-proxy {\r\n  border: 1px dashed #ddd;\r\n}\r\n#requestDaysOnOffModal .window-proxy-mask,\r\n#requestDaysOnOffModal .window-mask {\r\n  background: #eee;\r\n}\r\n#requestDaysOnOffModal .dialog-content {\r\n  overflow: auto;\r\n}\r\n#requestDaysOnOffModal .dialog-toolbar {\r\n  padding: 2px 5px;\r\n}\r\n#requestDaysOnOffModal .dialog-tool-separator {\r\n  float: left;\r\n  height: 24px;\r\n  border-left: 1px solid #ddd;\r\n  border-right: 1px solid #fff;\r\n  margin: 2px 1px;\r\n}\r\n#requestDaysOnOffModal .dialog-button {\r\n  padding: 5px;\r\n  text-align: right;\r\n}\r\n#requestDaysOnOffModal .dialog-button .l-btn {\r\n  margin-left: 5px;\r\n}\r\n#requestDaysOnOffModal .dialog-toolbar,\r\n#requestDaysOnOffModal .dialog-button {\r\n  background: #fff;\r\n}\r\n#requestDaysOnOffModal .dialog-toolbar {\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n#requestDaysOnOffModal .dialog-button {\r\n  border-top: 1px solid #ddd;\r\n}\r\n#requestDaysOnOffModal .textbox {\r\n  border: 1px solid #ddd;\r\n  vertical-align: middle;\r\n}\r\n#requestDaysOnOffModal .combo {\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n  margin: 0;\r\n  padding: 0;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  overflow: hidden;\r\n  vertical-align: middle;\r\n}\r\n#requestDaysOnOffModal .combo .combo-text {\r\n  font-size: 12px;\r\n  border: 0px;\r\n  line-height: 20px;\r\n  height: 20px;\r\n  margin: 0;\r\n  padding: 0px 2px;\r\n  *margin-top: -1px;\r\n  *height: 18px;\r\n  *line-height: 18px;\r\n  _height: 18px;\r\n  _line-height: 18px;\r\n  vertical-align: baseline;\r\n}\r\n#requestDaysOnOffModal .combo-arrow {\r\n  width: 18px;\r\n  height: 20px;\r\n  overflow: hidden;\r\n  display: inline-block;\r\n  vertical-align: top;\r\n  cursor: pointer;\r\n  opacity: 0.6;\r\n  filter: alpha(opacity=60);\r\n}\r\n#requestDaysOnOffModal .combo-arrow-hover {\r\n  opacity: 1.0;\r\n  filter: alpha(opacity=100);\r\n}\r\n#requestDaysOnOffModal .combo-panel {\r\n  overflow: auto;\r\n}\r\n#requestDaysOnOffModal .combo-arrow {\r\n    background: url('spritesheet.png') no-repeat -94px -5px;\r\n}\r\n#requestDaysOnOffModal .combo,\r\n#requestDaysOnOffModal .combo-panel {\r\n  background-color: #fff;\r\n}\r\n#requestDaysOnOffModal .combo {\r\n  border-color: #ddd;\r\n  background-color: #fff;\r\n}\r\n#requestDaysOnOffModal .combo-arrow {\r\n  background-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .combo-arrow-hover {\r\n  background-color: #E6E6E6;\r\n}\r\n#requestDaysOnOffModal .combobox-item,\r\n#requestDaysOnOffModal .combobox-group {\r\n  font-size: 12px;\r\n  padding: 3px;\r\n  padding-right: 0px;\r\n}\r\n#requestDaysOnOffModal .combobox-item-disabled {\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n}\r\n#requestDaysOnOffModal .combobox-gitem {\r\n  padding-left: 10px;\r\n}\r\n#requestDaysOnOffModal .combobox-group {\r\n  font-weight: bold;\r\n}\r\n#requestDaysOnOffModal .combobox-item-hover {\r\n  background-color: #E6E6E6;\r\n  color: #444;\r\n}\r\n#requestDaysOnOffModal .combobox-item-selected {\r\n  background-color: #CCE6FF;\r\n  color: #000;\r\n}\r\n#requestDaysOnOffModal .layout {\r\n  position: relative;\r\n  overflow: hidden;\r\n  margin: 0;\r\n  padding: 0;\r\n  z-index: 0;\r\n}\r\n#requestDaysOnOffModal .layout-panel {\r\n  position: absolute;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .layout-panel-east,\r\n#requestDaysOnOffModal .layout-panel-west {\r\n  z-index: 2;\r\n}\r\n#requestDaysOnOffModal .layout-panel-north,\r\n#requestDaysOnOffModal .layout-panel-south {\r\n  z-index: 3;\r\n}\r\n#requestDaysOnOffModal .layout-expand {\r\n  position: absolute;\r\n  padding: 0px;\r\n  font-size: 1px;\r\n  cursor: pointer;\r\n  z-index: 1;\r\n}\r\n#requestDaysOnOffModal .layout-expand .panel-header,\r\n#requestDaysOnOffModal .layout-expand .panel-body {\r\n  background: transparent;\r\n  filter: none;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .layout-expand .panel-header {\r\n  border-bottom-width: 0px;\r\n}\r\n#requestDaysOnOffModal .layout-split-proxy-h,\r\n#requestDaysOnOffModal .layout-split-proxy-v {\r\n  position: absolute;\r\n  font-size: 1px;\r\n  display: none;\r\n  z-index: 5;\r\n}\r\n#requestDaysOnOffModal .layout-split-proxy-h {\r\n  width: 5px;\r\n  cursor: e-resize;\r\n}\r\n#requestDaysOnOffModal .layout-split-proxy-v {\r\n  height: 5px;\r\n  cursor: n-resize;\r\n}\r\n#requestDaysOnOffModal .layout-mask {\r\n  position: absolute;\r\n  background: #fafafa;\r\n  filter: alpha(opacity=10);\r\n  opacity: 0.10;\r\n  z-index: 4;\r\n}\r\n#requestDaysOnOffModal .layout-button-up {\r\n    background: url('spritesheet.png') no-repeat -31px -57px;\r\n}\r\n#requestDaysOnOffModal .layout-button-down {\r\n    background: url('spritesheet.png') no-repeat -135px -31px;\r\n}\r\n#requestDaysOnOffModal .layout-button-left {\r\n    background: url('spritesheet.png') no-repeat -161px -31px;\r\n}\r\n#requestDaysOnOffModal .layout-button-right {\r\n    background: url('spritesheet.png') no-repeat -5px -57px;\r\n}\r\n#requestDaysOnOffModal .layout-split-proxy-h,\r\n#requestDaysOnOffModal .layout-split-proxy-v {\r\n  background-color: #b3b3b3;\r\n}\r\n#requestDaysOnOffModal .layout-split-north {\r\n  border-bottom: 5px solid #fff;\r\n}\r\n#requestDaysOnOffModal .layout-split-south {\r\n  border-top: 5px solid #fff;\r\n}\r\n#requestDaysOnOffModal .layout-split-east {\r\n  border-left: 5px solid #fff;\r\n}\r\n#requestDaysOnOffModal .layout-split-west {\r\n  border-right: 5px solid #fff;\r\n}\r\n#requestDaysOnOffModal .layout-expand {\r\n  background-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .layout-expand-over {\r\n  background-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .tabs-container {\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .tabs-header {\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-bottom-width: 0;\r\n  position: relative;\r\n  padding: 0;\r\n  padding-top: 2px;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .tabs-header-plain {\r\n  border: 0;\r\n  background: transparent;\r\n}\r\n#requestDaysOnOffModal .tabs-scroller-left,\r\n#requestDaysOnOffModal .tabs-scroller-right {\r\n  position: absolute;\r\n  top: auto;\r\n  bottom: 0;\r\n  width: 18px;\r\n  font-size: 1px;\r\n  display: none;\r\n  cursor: pointer;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .tabs-scroller-left {\r\n  left: 0;\r\n}\r\n#requestDaysOnOffModal .tabs-scroller-right {\r\n  right: 0;\r\n}\r\n#requestDaysOnOffModal .tabs-tool {\r\n  position: absolute;\r\n  bottom: 0;\r\n  padding: 1px;\r\n  overflow: hidden;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .tabs-header-plain .tabs-tool {\r\n  padding: 0 1px;\r\n}\r\n#requestDaysOnOffModal .tabs-wrap {\r\n  position: relative;\r\n  left: 0;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .tabs-scrolling {\r\n  margin-left: 18px;\r\n  margin-right: 18px;\r\n}\r\n#requestDaysOnOffModal .tabs-disabled {\r\n  opacity: 0.3;\r\n  filter: alpha(opacity=30);\r\n}\r\n#requestDaysOnOffModal .tabs {\r\n  list-style-type: none;\r\n  height: 26px;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  padding-left: 4px;\r\n  width: 5000px;\r\n  border-style: solid;\r\n  border-width: 0 0 1px 0;\r\n}\r\n#requestDaysOnOffModal .tabs li {\r\n  float: left;\r\n  display: inline-block;\r\n  margin: 0 4px -1px 0;\r\n  padding: 0;\r\n  position: relative;\r\n  border: 0;\r\n}\r\n#requestDaysOnOffModal .tabs li a.tabs-inner {\r\n  display: inline-block;\r\n  text-decoration: none;\r\n  margin: 0;\r\n  padding: 0 10px;\r\n  height: 25px;\r\n  line-height: 25px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  -moz-border-radius: 0px 0px 0 0;\r\n  -webkit-border-radius: 0px 0px 0 0;\r\n  border-radius: 0px 0px 0 0;\r\n}\r\n#requestDaysOnOffModal .tabs li.tabs-selected a.tabs-inner {\r\n  font-weight: bold;\r\n  outline: none;\r\n}\r\n#requestDaysOnOffModal .tabs li.tabs-selected a:hover.tabs-inner {\r\n  cursor: default;\r\n  pointer: default;\r\n}\r\n#requestDaysOnOffModal .tabs li a.tabs-close,\r\n#requestDaysOnOffModal .tabs-p-tool {\r\n  position: absolute;\r\n  font-size: 1px;\r\n  display: block;\r\n  height: 12px;\r\n  padding: 0;\r\n  top: 50%;\r\n  margin-top: -6px;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .tabs li a.tabs-close {\r\n  width: 12px;\r\n  right: 5px;\r\n  opacity: 0.6;\r\n  filter: alpha(opacity=60);\r\n}\r\n#requestDaysOnOffModal .tabs-p-tool {\r\n  right: 16px;\r\n}\r\n#requestDaysOnOffModal .tabs-p-tool a {\r\n  display: inline-block;\r\n  font-size: 1px;\r\n  width: 12px;\r\n  height: 12px;\r\n  margin: 0;\r\n  opacity: 0.6;\r\n  filter: alpha(opacity=60);\r\n}\r\n#requestDaysOnOffModal .tabs li a:hover.tabs-close,\r\n#requestDaysOnOffModal .tabs-p-tool a:hover {\r\n  opacity: 1;\r\n  filter: alpha(opacity=100);\r\n  cursor: hand;\r\n  cursor: pointer;\r\n}\r\n#requestDaysOnOffModal .tabs-with-icon {\r\n  padding-left: 18px;\r\n}\r\n#requestDaysOnOffModal .tabs-icon {\r\n  position: absolute;\r\n  width: 16px;\r\n  height: 16px;\r\n  left: 10px;\r\n  top: 50%;\r\n  margin-top: -8px;\r\n}\r\n#requestDaysOnOffModal .tabs-title {\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .tabs-closable {\r\n  padding-right: 8px;\r\n}\r\n#requestDaysOnOffModal .tabs-panels {\r\n  margin: 0px;\r\n  padding: 0px;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-top-width: 0;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .tabs-header-bottom {\r\n  border-width: 0 1px 1px 1px;\r\n  padding: 0 0 2px 0;\r\n}\r\n#requestDaysOnOffModal .tabs-header-bottom .tabs {\r\n  border-width: 1px 0 0 0;\r\n}\r\n#requestDaysOnOffModal .tabs-header-bottom .tabs li {\r\n  margin: -1px 4px 0 0;\r\n}\r\n#requestDaysOnOffModal .tabs-header-bottom .tabs li a.tabs-inner {\r\n  -moz-border-radius: 0 0 0px 0px;\r\n  -webkit-border-radius: 0 0 0px 0px;\r\n  border-radius: 0 0 0px 0px;\r\n}\r\n#requestDaysOnOffModal .tabs-header-bottom .tabs-tool {\r\n  top: 0;\r\n}\r\n#requestDaysOnOffModal .tabs-header-bottom .tabs-scroller-left,\r\n#requestDaysOnOffModal .tabs-header-bottom .tabs-scroller-right {\r\n  top: 0;\r\n  bottom: auto;\r\n}\r\n#requestDaysOnOffModal .tabs-panels-top {\r\n  border-width: 1px 1px 0 1px;\r\n}\r\n#requestDaysOnOffModal .tabs-header-left {\r\n  float: left;\r\n  border-width: 1px 0 1px 1px;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .tabs-header-right {\r\n  float: right;\r\n  border-width: 1px 1px 1px 0;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .tabs-header-left .tabs-wrap,\r\n#requestDaysOnOffModal .tabs-header-right .tabs-wrap {\r\n  height: 100%;\r\n}\r\n#requestDaysOnOffModal .tabs-header-left .tabs {\r\n  height: 100%;\r\n  padding: 4px 0 0 4px;\r\n  border-width: 0 1px 0 0;\r\n}\r\n#requestDaysOnOffModal .tabs-header-right .tabs {\r\n  height: 100%;\r\n  padding: 4px 4px 0 0;\r\n  border-width: 0 0 0 1px;\r\n}\r\n#requestDaysOnOffModal .tabs-header-left .tabs li,\r\n#requestDaysOnOffModal .tabs-header-right .tabs li {\r\n  display: block;\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n#requestDaysOnOffModal .tabs-header-left .tabs li {\r\n  left: auto;\r\n  right: 0;\r\n  margin: 0 -1px 4px 0;\r\n  float: right;\r\n}\r\n#requestDaysOnOffModal .tabs-header-right .tabs li {\r\n  left: 0;\r\n  right: auto;\r\n  margin: 0 0 4px -1px;\r\n  float: left;\r\n}\r\n#requestDaysOnOffModal .tabs-header-left .tabs li a.tabs-inner {\r\n  display: block;\r\n  text-align: left;\r\n  -moz-border-radius: 0px 0 0 0px;\r\n  -webkit-border-radius: 0px 0 0 0px;\r\n  border-radius: 0px 0 0 0px;\r\n}\r\n#requestDaysOnOffModal .tabs-header-right .tabs li a.tabs-inner {\r\n  display: block;\r\n  text-align: left;\r\n  -moz-border-radius: 0 0px 0px 0;\r\n  -webkit-border-radius: 0 0px 0px 0;\r\n  border-radius: 0 0px 0px 0;\r\n}\r\n#requestDaysOnOffModal .tabs-panels-right {\r\n  float: right;\r\n  border-width: 1px 1px 1px 0;\r\n}\r\n#requestDaysOnOffModal .tabs-panels-left {\r\n  float: left;\r\n  border-width: 1px 0 1px 1px;\r\n}\r\n#requestDaysOnOffModal .tabs-header-noborder,\r\n#requestDaysOnOffModal .tabs-panels-noborder {\r\n  border: 0px;\r\n}\r\n#requestDaysOnOffModal .tabs-header-plain {\r\n  border: 0px;\r\n  background: transparent;\r\n}\r\n#requestDaysOnOffModal .tabs-scroller-left {\r\n  background: #ffffff url('images/tabs_icons.png') no-repeat 1px center;\r\n}\r\n#requestDaysOnOffModal .tabs-scroller-right {\r\n  background: #ffffff url('images/tabs_icons.png') no-repeat -15px center;\r\n}\r\n#requestDaysOnOffModal .tabs li a.tabs-close {\r\n  background: url('images/tabs_icons.png') no-repeat -34px center;\r\n}\r\n#requestDaysOnOffModal .tabs li a.tabs-inner:hover {\r\n  background: #E6E6E6;\r\n  color: #444;\r\n  filter: none;\r\n}\r\n#requestDaysOnOffModal .tabs li.tabs-selected a.tabs-inner {\r\n  background-color: #fff;\r\n  color: #777;\r\n}\r\n#requestDaysOnOffModal .tabs li a.tabs-inner {\r\n  color: #777;\r\n  background-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .tabs-header,\r\n#requestDaysOnOffModal .tabs-tool {\r\n  background-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .tabs-header-plain {\r\n  background: transparent;\r\n}\r\n#requestDaysOnOffModal .tabs-header,\r\n#requestDaysOnOffModal .tabs-scroller-left,\r\n#requestDaysOnOffModal .tabs-scroller-right,\r\n#requestDaysOnOffModal .tabs-tool,\r\n#requestDaysOnOffModal .tabs,\r\n#requestDaysOnOffModal .tabs-panels,\r\n#requestDaysOnOffModal .tabs li a.tabs-inner,\r\n#requestDaysOnOffModal .tabs li.tabs-selected a.tabs-inner,\r\n#requestDaysOnOffModal .tabs-header-bottom .tabs li.tabs-selected a.tabs-inner,\r\n#requestDaysOnOffModal .tabs-header-left .tabs li.tabs-selected a.tabs-inner,\r\n#requestDaysOnOffModal .tabs-header-right .tabs li.tabs-selected a.tabs-inner {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .tabs-p-tool a:hover,\r\n#requestDaysOnOffModal .tabs li a:hover.tabs-close,\r\n#requestDaysOnOffModal .tabs-scroller-over {\r\n  background-color: #E6E6E6;\r\n}\r\n#requestDaysOnOffModal .tabs li.tabs-selected a.tabs-inner {\r\n  border-bottom: 1px solid #fff;\r\n}\r\n#requestDaysOnOffModal .tabs-header-bottom .tabs li.tabs-selected a.tabs-inner {\r\n  border-top: 1px solid #fff;\r\n}\r\n#requestDaysOnOffModal .tabs-header-left .tabs li.tabs-selected a.tabs-inner {\r\n  border-right: 1px solid #fff;\r\n}\r\n#requestDaysOnOffModal .tabs-header-right .tabs li.tabs-selected a.tabs-inner {\r\n  border-left: 1px solid #fff;\r\n}\r\n#requestDaysOnOffModal .l-btn {\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  margin: 0;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  outline: none;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n}\r\n#requestDaysOnOffModal .l-btn-plain {\r\n  border: 0;\r\n  padding: 1px;\r\n}\r\n#requestDaysOnOffModal .l-btn-disabled {\r\n  color: #ccc;\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n  cursor: default;\r\n}\r\n#requestDaysOnOffModal .l-btn-left {\r\n  display: inline-block;\r\n  position: relative;\r\n  overflow: hidden;\r\n  margin: 0;\r\n  padding: 0;\r\n  vertical-align: top;\r\n}\r\n#requestDaysOnOffModal .l-btn-text {\r\n  display: inline-block;\r\n  vertical-align: top;\r\n  width: auto;\r\n  line-height: 24px;\r\n  font-size: 12px;\r\n  padding: 0;\r\n  margin: 0 4px;\r\n}\r\n#requestDaysOnOffModal .l-btn-icon {\r\n  display: inline-block;\r\n  width: 16px;\r\n  height: 16px;\r\n  line-height: 16px;\r\n  position: absolute;\r\n  top: 50%;\r\n  margin-top: -8px;\r\n  font-size: 1px;\r\n}\r\n#requestDaysOnOffModal .l-btn span span .l-btn-empty {\r\n  display: inline-block;\r\n  margin: 0;\r\n  width: 16px;\r\n  height: 24px;\r\n  font-size: 1px;\r\n  vertical-align: top;\r\n}\r\n#requestDaysOnOffModal .l-btn span .l-btn-icon-left {\r\n  padding: 0 0 0 20px;\r\n  background-position: left center;\r\n}\r\n#requestDaysOnOffModal .l-btn span .l-btn-icon-right {\r\n  padding: 0 20px 0 0;\r\n  background-position: right center;\r\n}\r\n#requestDaysOnOffModal .l-btn-icon-left .l-btn-text {\r\n  margin: 0 4px 0 24px;\r\n}\r\n#requestDaysOnOffModal .l-btn-icon-left .l-btn-icon {\r\n  left: 4px;\r\n}\r\n#requestDaysOnOffModal .l-btn-icon-right .l-btn-text {\r\n  margin: 0 24px 0 4px;\r\n}\r\n#requestDaysOnOffModal .l-btn-icon-right .l-btn-icon {\r\n  right: 4px;\r\n}\r\n#requestDaysOnOffModal .l-btn-icon-top .l-btn-text {\r\n  margin: 20px 4px 0 4px;\r\n}\r\n#requestDaysOnOffModal .l-btn-icon-top .l-btn-icon {\r\n  top: 4px;\r\n  left: 50%;\r\n  margin: 0 0 0 -8px;\r\n}\r\n#requestDaysOnOffModal .l-btn-icon-bottom .l-btn-text {\r\n  margin: 0 4px 20px 4px;\r\n}\r\n#requestDaysOnOffModal .l-btn-icon-bottom .l-btn-icon {\r\n  top: auto;\r\n  bottom: 4px;\r\n  left: 50%;\r\n  margin: 0 0 0 -8px;\r\n}\r\n#requestDaysOnOffModal .l-btn-left .l-btn-empty {\r\n  margin: 0 4px;\r\n  width: 16px;\r\n}\r\n#requestDaysOnOffModal .l-btn-plain:hover {\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .l-btn-focus {\r\n  outline: #0000FF dotted thin;\r\n}\r\n#requestDaysOnOffModal .l-btn-large .l-btn-text {\r\n  line-height: 40px;\r\n}\r\n#requestDaysOnOffModal .l-btn-large .l-btn-icon {\r\n  width: 32px;\r\n  height: 32px;\r\n  line-height: 32px;\r\n  margin-top: -16px;\r\n}\r\n#requestDaysOnOffModal .l-btn-large .l-btn-icon-left .l-btn-text {\r\n  margin-left: 40px;\r\n}\r\n#requestDaysOnOffModal .l-btn-large .l-btn-icon-right .l-btn-text {\r\n  margin-right: 40px;\r\n}\r\n#requestDaysOnOffModal .l-btn-large .l-btn-icon-top .l-btn-text {\r\n  margin-top: 36px;\r\n  line-height: 24px;\r\n  min-width: 32px;\r\n}\r\n#requestDaysOnOffModal .l-btn-large .l-btn-icon-top .l-btn-icon {\r\n  margin: 0 0 0 -16px;\r\n}\r\n#requestDaysOnOffModal .l-btn-large .l-btn-icon-bottom .l-btn-text {\r\n  margin-bottom: 36px;\r\n  line-height: 24px;\r\n  min-width: 32px;\r\n}\r\n#requestDaysOnOffModal .l-btn-large .l-btn-icon-bottom .l-btn-icon {\r\n  margin: 0 0 0 -16px;\r\n}\r\n#requestDaysOnOffModal .l-btn-large .l-btn-left .l-btn-empty {\r\n  margin: 0 4px;\r\n  width: 32px;\r\n}\r\n#requestDaysOnOffModal .l-btn {\r\n  color: #777;\r\n  background: #ffffff;\r\n  background-repeat: repeat-x;\r\n  border: 1px solid #dddddd;\r\n  background: -webkit-linear-gradient(top,#ffffff 0,#ffffff 100%);\r\n  background: -moz-linear-gradient(top,#ffffff 0,#ffffff 100%);\r\n  background: -o-linear-gradient(top,#ffffff 0,#ffffff 100%);\r\n  background: linear-gradient(to bottom,#ffffff 0,#ffffff 100%);\r\n  background-repeat: repeat-x;\r\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff,endColorstr=#ffffff,GradientType=0);\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .l-btn:hover {\r\n  background: #E6E6E6;\r\n  color: #444;\r\n  border: 1px solid #ddd;\r\n  filter: none;\r\n}\r\n#requestDaysOnOffModal .l-btn-plain {\r\n  background: transparent;\r\n  border: 0;\r\n  filter: none;\r\n}\r\n#requestDaysOnOffModal .l-btn-plain:hover {\r\n  background: #E6E6E6;\r\n  color: #444;\r\n  border: 1px solid #ddd;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .l-btn-disabled,\r\n#requestDaysOnOffModal .l-btn-disabled:hover {\r\n  background: #ffffff;\r\n  color: #777;\r\n  background: -webkit-linear-gradient(top,#ffffff 0,#ffffff 100%);\r\n  background: -moz-linear-gradient(top,#ffffff 0,#ffffff 100%);\r\n  background: -o-linear-gradient(top,#ffffff 0,#ffffff 100%);\r\n  background: linear-gradient(to bottom,#ffffff 0,#ffffff 100%);\r\n  background-repeat: repeat-x;\r\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff,endColorstr=#ffffff,GradientType=0);\r\n  filter: alpha(opacity=50) progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff,endColorstr=#ffffff,GradientType=0);\r\n}\r\n#requestDaysOnOffModal .l-btn-plain-disabled,\r\n#requestDaysOnOffModal .l-btn-plain-disabled:hover {\r\n  background: transparent;\r\n  filter: alpha(opacity=50);\r\n}\r\n#requestDaysOnOffModal .l-btn-selected,\r\n#requestDaysOnOffModal .l-btn-selected:hover {\r\n  background: #ddd;\r\n  filter: none;\r\n}\r\n#requestDaysOnOffModal .l-btn-plain-selected,\r\n#requestDaysOnOffModal .l-btn-plain-selected:hover {\r\n  background: #ddd;\r\n}\r\n#requestDaysOnOffModal .datagrid .panel-body {\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n#requestDaysOnOffModal .datagrid-view {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .datagrid-view1,\r\n#requestDaysOnOffModal .datagrid-view2 {\r\n  position: absolute;\r\n  overflow: hidden;\r\n  top: 0;\r\n}\r\n#requestDaysOnOffModal .datagrid-view1 {\r\n  left: 0;\r\n}\r\n#requestDaysOnOffModal .datagrid-view2 {\r\n  right: 0;\r\n}\r\n#requestDaysOnOffModal .datagrid-mask {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: 0.3;\r\n  filter: alpha(opacity=30);\r\n  display: none;\r\n}\r\n#requestDaysOnOffModal .datagrid-mask-msg {\r\n  position: absolute;\r\n  top: 50%;\r\n  margin-top: -20px;\r\n  padding: 10px 5px 10px 30px;\r\n  width: auto;\r\n  height: 16px;\r\n  border-width: 2px;\r\n  border-style: solid;\r\n  display: none;\r\n}\r\n#requestDaysOnOffModal .datagrid-sort-icon {\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .datagrid-toolbar {\r\n  height: auto;\r\n  padding: 1px 2px;\r\n  border-width: 0 0 1px 0;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .datagrid-btn-separator {\r\n  float: left;\r\n  height: 24px;\r\n  border-left: 1px solid #ddd;\r\n  border-right: 1px solid #fff;\r\n  margin: 2px 1px;\r\n}\r\n#requestDaysOnOffModal .datagrid .datagrid-pager {\r\n  display: block;\r\n  margin: 0;\r\n  border-width: 1px 0 0 0;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .datagrid .datagrid-pager-top {\r\n  border-width: 0 0 1px 0;\r\n}\r\n#requestDaysOnOffModal .datagrid-header {\r\n  overflow: hidden;\r\n  cursor: default;\r\n  border-width: 0 0 1px 0;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .datagrid-header-inner {\r\n  float: left;\r\n  width: 10000px;\r\n}\r\n#requestDaysOnOffModal .datagrid-header-row,\r\n#requestDaysOnOffModal .datagrid-row {\r\n  height: 25px;\r\n}\r\n#requestDaysOnOffModal .datagrid-header td,\r\n#requestDaysOnOffModal .datagrid-body td,\r\n#requestDaysOnOffModal .datagrid-footer td {\r\n  border-width: 0 1px 1px 0;\r\n  border-style: dotted;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .datagrid-cell,\r\n#requestDaysOnOffModal .datagrid-cell-group,\r\n#requestDaysOnOffModal .datagrid-header-rownumber,\r\n#requestDaysOnOffModal .datagrid-cell-rownumber {\r\n  margin: 0;\r\n  padding: 0 4px;\r\n  white-space: nowrap;\r\n  word-wrap: normal;\r\n  overflow: hidden;\r\n  height: 18px;\r\n  line-height: 18px;\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .datagrid-header .datagrid-cell {\r\n  height: auto;\r\n}\r\n#requestDaysOnOffModal .datagrid-header .datagrid-cell span {\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .datagrid-cell-group {\r\n  text-align: center;\r\n}\r\n#requestDaysOnOffModal .datagrid-header-rownumber,\r\n#requestDaysOnOffModal .datagrid-cell-rownumber {\r\n  width: 25px;\r\n  text-align: center;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .datagrid-body {\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow: auto;\r\n  zoom: 1;\r\n}\r\n#requestDaysOnOffModal .datagrid-view1 .datagrid-body-inner {\r\n  padding-bottom: 20px;\r\n}\r\n#requestDaysOnOffModal .datagrid-view1 .datagrid-body {\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .datagrid-footer {\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .datagrid-footer-inner {\r\n  border-width: 1px 0 0 0;\r\n  border-style: solid;\r\n  width: 10000px;\r\n  float: left;\r\n}\r\n#requestDaysOnOffModal .datagrid-row-editing .datagrid-cell {\r\n  height: auto;\r\n}\r\n#requestDaysOnOffModal .datagrid-header-check,\r\n#requestDaysOnOffModal .datagrid-cell-check {\r\n  padding: 0;\r\n  width: 27px;\r\n  height: 18px;\r\n  font-size: 1px;\r\n  text-align: center;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .datagrid-header-check input,\r\n#requestDaysOnOffModal .datagrid-cell-check input {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 15px;\r\n  height: 18px;\r\n}\r\n#requestDaysOnOffModal .datagrid-resize-proxy {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 10000px;\r\n  top: 0;\r\n  cursor: e-resize;\r\n  display: none;\r\n}\r\n#requestDaysOnOffModal .datagrid-body .datagrid-editable {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .datagrid-body .datagrid-editable table {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n#requestDaysOnOffModal .datagrid-body .datagrid-editable td {\r\n  border: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .datagrid-body .datagrid-editable .datagrid-editable-input {\r\n  margin: 0;\r\n  padding: 2px;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .datagrid-sort-desc .datagrid-sort-icon {\r\n    padding: 0 13px 0 0;\r\n    background: url('spritesheet.png') no-repeat -31px -31px;\r\n}\r\n#requestDaysOnOffModal .datagrid-sort-asc .datagrid-sort-icon {\r\n    padding: 0 13px 0 0;\r\n    background: url('spritesheet.png') no-repeat -5px -31px;\r\n}\r\n#requestDaysOnOffModal .datagrid-row-collapse {\r\n    background: url('spritesheet.png') no-repeat -146px -5px;\r\n}\r\n#requestDaysOnOffModal .datagrid-row-expand {\r\n    background: url('spritesheet.png') no-repeat -172px -5px;\r\n}\r\n#requestDaysOnOffModal .datagrid-mask-msg {\r\n  background: #fff url('images/loading.gif') no-repeat scroll 5px center;\r\n}\r\n#requestDaysOnOffModal .datagrid-header,\r\n#requestDaysOnOffModal .datagrid-td-rownumber {\r\n  background-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .datagrid-cell-rownumber {\r\n  color: #444;\r\n}\r\n#requestDaysOnOffModal .datagrid-resize-proxy {\r\n  background: #b3b3b3;\r\n}\r\n#requestDaysOnOffModal .datagrid-mask {\r\n  background: #eee;\r\n}\r\n#requestDaysOnOffModal .datagrid-mask-msg {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .datagrid-toolbar,\r\n#requestDaysOnOffModal .datagrid-pager {\r\n  background: #fff;\r\n}\r\n#requestDaysOnOffModal .datagrid-header,\r\n#requestDaysOnOffModal .datagrid-toolbar,\r\n#requestDaysOnOffModal .datagrid-pager,\r\n#requestDaysOnOffModal .datagrid-footer-inner {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .datagrid-header td,\r\n#requestDaysOnOffModal .datagrid-body td,\r\n#requestDaysOnOffModal .datagrid-footer td {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .datagrid-htable,\r\n#requestDaysOnOffModal .datagrid-btable,\r\n#requestDaysOnOffModal .datagrid-ftable {\r\n  color: #444;\r\n  border-collapse: separate;\r\n}\r\n#requestDaysOnOffModal .datagrid-row-alt {\r\n  background: #f5f5f5;\r\n}\r\n#requestDaysOnOffModal .datagrid-row-over,\r\n#requestDaysOnOffModal .datagrid-header td.datagrid-header-over {\r\n  background: #E6E6E6;\r\n  color: #444;\r\n  cursor: default;\r\n}\r\n#requestDaysOnOffModal .datagrid-row-selected {\r\n  background: #CCE6FF;\r\n  color: #000;\r\n}\r\n#requestDaysOnOffModal .datagrid-body .datagrid-editable .datagrid-editable-input {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-body td {\r\n  padding-bottom: 1px;\r\n  border-width: 0 1px 0 0;\r\n}\r\n#requestDaysOnOffModal .propertygrid .datagrid-group {\r\n  height: 21px;\r\n  overflow: hidden;\r\n  border-width: 0 0 1px 0;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .propertygrid .datagrid-group span {\r\n  font-weight: bold;\r\n}\r\n#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-body td {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-group {\r\n  border-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .propertygrid .datagrid-view2 .datagrid-group {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .propertygrid .datagrid-group,\r\n#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-body,\r\n#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-row-over,\r\n#requestDaysOnOffModal .propertygrid .datagrid-view1 .datagrid-row-selected {\r\n  background: #ffffff;\r\n}\r\n#requestDaysOnOffModal .pagination {\r\n  zoom: 1;\r\n}\r\n#requestDaysOnOffModal .pagination table {\r\n  float: left;\r\n  height: 30px;\r\n}\r\n#requestDaysOnOffModal .pagination td {\r\n  border: 0;\r\n}\r\n#requestDaysOnOffModal .pagination-btn-separator {\r\n  float: left;\r\n  height: 24px;\r\n  border-left: 1px solid #ddd;\r\n  border-right: 1px solid #fff;\r\n  margin: 3px 1px;\r\n}\r\n#requestDaysOnOffModal .pagination .pagination-num {\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  margin: 0 2px;\r\n  padding: 2px;\r\n  width: 2em;\r\n  height: auto;\r\n}\r\n#requestDaysOnOffModal .pagination-page-list {\r\n  margin: 0px 6px;\r\n  padding: 1px 2px;\r\n  width: auto;\r\n  height: auto;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .pagination-info {\r\n  float: right;\r\n  margin: 0 6px 0 0;\r\n  padding: 0;\r\n  height: 30px;\r\n  line-height: 30px;\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .pagination span {\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .pagination-link .l-btn-text {\r\n  width: 24px;\r\n  text-align: center;\r\n  margin: 0;\r\n}\r\n#requestDaysOnOffModal .pagination-first {\r\n    background: url('spritesheet.png') no-repeat -157px -125px;\r\n}\r\n#requestDaysOnOffModal .pagination-prev {\r\n    background: url('spritesheet.png') no-repeat -83px -151px;\r\n}\r\n#requestDaysOnOffModal .pagination-next {\r\n    background: url('spritesheet.png') no-repeat -57px -151px;\r\n}\r\n#requestDaysOnOffModal .pagination-last {\r\n    background: url('spritesheet.png') no-repeat -5px -151px;\r\n}\r\n#requestDaysOnOffModal .pagination-load {\r\n    background: url('spritesheet.png') no-repeat -31px -151px;\r\n}\r\n#requestDaysOnOffModal .pagination-loading {\r\n  background: url('images/loading.gif') no-repeat center center;\r\n}\r\n#requestDaysOnOffModal .pagination-page-list,\r\n#requestDaysOnOffModal .pagination .pagination-num {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .calendar {\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  padding: 1px;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .calendar table {\r\n  table-layout: fixed;\r\n  border-collapse: separate;\r\n  font-size: 12px;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n#requestDaysOnOffModal .calendar table td,\r\n#requestDaysOnOffModal .calendar table th {\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .calendar-noborder {\r\n  border: 0;\r\n}\r\n#requestDaysOnOffModal .calendar-header {\r\n  position: relative;\r\n  height: 22px;\r\n}\r\n#requestDaysOnOffModal .calendar-title {\r\n  text-align: center;\r\n  height: 22px;\r\n}\r\n#requestDaysOnOffModal .calendar-title span {\r\n  position: relative;\r\n  display: inline-block;\r\n  top: 2px;\r\n  padding: 0 3px;\r\n  height: 18px;\r\n  line-height: 18px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .calendar-prevmonth,\r\n#requestDaysOnOffModal .calendar-nextmonth,\r\n#requestDaysOnOffModal .calendar-prevyear,\r\n#requestDaysOnOffModal .calendar-nextyear {\r\n  position: absolute;\r\n  top: 50%;\r\n  margin-top: -7px;\r\n  width: 14px;\r\n  height: 14px;\r\n  cursor: pointer;\r\n  font-size: 1px;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .calendar-prevmonth {\r\n  left: 20px;\r\n  background: url('images/calendar_arrows.png') no-repeat -18px -2px;\r\n}\r\n#requestDaysOnOffModal .calendar-nextmonth {\r\n  right: 20px;\r\n  background: url('images/calendar_arrows.png') no-repeat -34px -2px;\r\n}\r\n#requestDaysOnOffModal .calendar-prevyear {\r\n  left: 3px;\r\n  background: url('images/calendar_arrows.png') no-repeat -1px -2px;\r\n}\r\n#requestDaysOnOffModal .calendar-nextyear {\r\n  right: 3px;\r\n  background: url('images/calendar_arrows.png') no-repeat -49px -2px;\r\n}\r\n#requestDaysOnOffModal .calendar-body {\r\n  position: relative;\r\n}\r\n#requestDaysOnOffModal .calendar-body th,\r\n#requestDaysOnOffModal .calendar-body td {\r\n  text-align: center;\r\n}\r\n#requestDaysOnOffModal .calendar-day {\r\n  border: 0;\r\n  padding: 1px;\r\n  cursor: pointer;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .calendar-other-month {\r\n  opacity: 0.3;\r\n  filter: alpha(opacity=30);\r\n}\r\n#requestDaysOnOffModal .calendar-disabled {\r\n  opacity: 0.6;\r\n  filter: alpha(opacity=60);\r\n  cursor: default;\r\n}\r\n#requestDaysOnOffModal .calendar-menu {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 180px;\r\n  height: 150px;\r\n  padding: 5px;\r\n  font-size: 12px;\r\n  display: none;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .calendar-menu-year-inner {\r\n  text-align: center;\r\n  padding-bottom: 5px;\r\n}\r\n#requestDaysOnOffModal .calendar-menu-year {\r\n  width: 40px;\r\n  text-align: center;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  margin: 0;\r\n  padding: 2px;\r\n  font-weight: bold;\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .calendar-menu-prev,\r\n#requestDaysOnOffModal .calendar-menu-next {\r\n  display: inline-block;\r\n  width: 21px;\r\n  height: 21px;\r\n  vertical-align: top;\r\n  cursor: pointer;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .calendar-menu-prev {\r\n  margin-right: 10px;\r\n  background: url('images/calendar_arrows.png') no-repeat 2px 2px;\r\n}\r\n#requestDaysOnOffModal .calendar-menu-next {\r\n  margin-left: 10px;\r\n  background: url('images/calendar_arrows.png') no-repeat -45px 2px;\r\n}\r\n#requestDaysOnOffModal .calendar-menu-month {\r\n  text-align: center;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .calendar-body th,\r\n#requestDaysOnOffModal .calendar-menu-month {\r\n  color: #919191;\r\n}\r\n#requestDaysOnOffModal .calendar-day {\r\n  color: #444;\r\n}\r\n#requestDaysOnOffModal .calendar-sunday {\r\n  color: #CC2222;\r\n}\r\n#requestDaysOnOffModal .calendar-saturday {\r\n  color: #00ee00;\r\n}\r\n#requestDaysOnOffModal .calendar-today {\r\n  color: #0000ff;\r\n}\r\n#requestDaysOnOffModal .calendar-menu-year {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .calendar {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .calendar-header {\r\n  background: #ffffff;\r\n}\r\n#requestDaysOnOffModal .calendar-body,\r\n#requestDaysOnOffModal .calendar-menu {\r\n  background: #fff;\r\n}\r\n#requestDaysOnOffModal .calendar-body th {\r\n  background: #fff;\r\n  padding: 2px 0;\r\n}\r\n#requestDaysOnOffModal .calendar-hover,\r\n#requestDaysOnOffModal .calendar-nav-hover,\r\n#requestDaysOnOffModal .calendar-menu-hover {\r\n  background-color: #E6E6E6;\r\n  color: #444;\r\n}\r\n#requestDaysOnOffModal .calendar-hover {\r\n  border: 1px solid #ddd;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .calendar-selected {\r\n  background-color: #CCE6FF;\r\n  color: #000;\r\n  border: 1px solid #99cdff;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .datebox-calendar-inner {\r\n  height: 180px;\r\n}\r\n#requestDaysOnOffModal .datebox-button {\r\n  height: 18px;\r\n  padding: 2px 5px;\r\n  text-align: center;\r\n}\r\n#requestDaysOnOffModal .datebox-button a {\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  text-decoration: none;\r\n  opacity: 0.6;\r\n  filter: alpha(opacity=60);\r\n}\r\n#requestDaysOnOffModal .datebox-button a:hover {\r\n  opacity: 1.0;\r\n  filter: alpha(opacity=100);\r\n}\r\n#requestDaysOnOffModal .datebox-current,\r\n#requestDaysOnOffModal .datebox-close {\r\n  float: left;\r\n}\r\n#requestDaysOnOffModal .datebox-close {\r\n  float: right;\r\n}\r\n#requestDaysOnOffModal .datebox .combo-arrow {\r\n    background: url('spritesheet.png') no-repeat -57px -31px;\r\n}\r\n#requestDaysOnOffModal .datebox-button {\r\n  background-color: #fff;\r\n}\r\n#requestDaysOnOffModal .datebox-button a {\r\n  color: #777;\r\n}\r\n#requestDaysOnOffModal .numberbox {\r\n  border: 1px solid #ddd;\r\n  margin: 0;\r\n  padding: 0 2px;\r\n  vertical-align: middle;\r\n}\r\n#requestDaysOnOffModal .spinner {\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n  margin: 0;\r\n  padding: 0;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  overflow: hidden;\r\n  vertical-align: middle;\r\n}\r\n#requestDaysOnOffModal .spinner .spinner-text {\r\n  font-size: 12px;\r\n  border: 0px;\r\n  line-height: 20px;\r\n  height: 20px;\r\n  margin: 0;\r\n  padding: 0 2px;\r\n  *margin-top: -1px;\r\n  *height: 18px;\r\n  *line-height: 18px;\r\n  _height: 18px;\r\n  _line-height: 18px;\r\n  vertical-align: baseline;\r\n}\r\n#requestDaysOnOffModal .spinner-arrow {\r\n  display: inline-block;\r\n  overflow: hidden;\r\n  vertical-align: top;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .spinner-arrow-up,\r\n#requestDaysOnOffModal .spinner-arrow-down {\r\n  opacity: 0.6;\r\n  filter: alpha(opacity=60);\r\n  display: block;\r\n  font-size: 1px;\r\n  width: 18px;\r\n  height: 10px;\r\n}\r\n#requestDaysOnOffModal .spinner-arrow-hover {\r\n  opacity: 1.0;\r\n  filter: alpha(opacity=100);\r\n}\r\n#requestDaysOnOffModal .spinner-arrow-up {\r\n    background: url('spritesheet.png') no-repeat -191px -109px;\r\n}\r\n#requestDaysOnOffModal .spinner-arrow-down {\r\n    background: url('spritesheet.png') no-repeat -203px -83px;\r\n}\r\n#requestDaysOnOffModal .spinner {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .spinner-arrow {\r\n  background-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .spinner-arrow-hover {\r\n  background-color: #E6E6E6;\r\n}\r\n#requestDaysOnOffModal .progressbar {\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n#requestDaysOnOffModal .progressbar-text {\r\n  text-align: center;\r\n  position: absolute;\r\n}\r\n#requestDaysOnOffModal .progressbar-value {\r\n  position: relative;\r\n  overflow: hidden;\r\n  width: 0;\r\n  -moz-border-radius: 0px 0 0 0px;\r\n  -webkit-border-radius: 0px 0 0 0px;\r\n  border-radius: 0px 0 0 0px;\r\n}\r\n#requestDaysOnOffModal .progressbar {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .progressbar-text {\r\n  color: #444;\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .progressbar-value .progressbar-text {\r\n  background-color: #CCE6FF;\r\n  color: #000;\r\n}\r\n#requestDaysOnOffModal .searchbox {\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n  margin: 0;\r\n  padding: 0;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  overflow: hidden;\r\n  vertical-align: middle;\r\n}\r\n#requestDaysOnOffModal .searchbox .searchbox-text {\r\n  font-size: 12px;\r\n  border: 0;\r\n  margin: 0;\r\n  padding: 0 2px;\r\n  *margin-top: -1px;\r\n  vertical-align: top;\r\n}\r\n#requestDaysOnOffModal .searchbox .searchbox-prompt {\r\n  font-size: 12px;\r\n  color: #ccc;\r\n}\r\n#requestDaysOnOffModal .searchbox-button {\r\n  width: 18px;\r\n  height: 20px;\r\n  overflow: hidden;\r\n  display: inline-block;\r\n  vertical-align: top;\r\n  cursor: pointer;\r\n  opacity: 0.6;\r\n  filter: alpha(opacity=60);\r\n}\r\n#requestDaysOnOffModal .searchbox-button-hover {\r\n  opacity: 1.0;\r\n  filter: alpha(opacity=100);\r\n}\r\n#requestDaysOnOffModal .searchbox .l-btn-plain {\r\n  border: 0;\r\n  padding: 0;\r\n  vertical-align: top;\r\n  opacity: 0.6;\r\n  filter: alpha(opacity=60);\r\n  -moz-border-radius: 0 0 0 0;\r\n  -webkit-border-radius: 0 0 0 0;\r\n  border-radius: 0 0 0 0;\r\n}\r\n#requestDaysOnOffModal .searchbox .l-btn-plain:hover {\r\n  border: 0;\r\n  padding: 0;\r\n  opacity: 1.0;\r\n  filter: alpha(opacity=100);\r\n  -moz-border-radius: 0 0 0 0;\r\n  -webkit-border-radius: 0 0 0 0;\r\n  border-radius: 0 0 0 0;\r\n}\r\n#requestDaysOnOffModal .searchbox a.m-btn-plain-active {\r\n  -moz-border-radius: 0 0 0 0;\r\n  -webkit-border-radius: 0 0 0 0;\r\n  border-radius: 0 0 0 0;\r\n}\r\n#requestDaysOnOffModal .searchbox-button {\r\n    background: url('spritesheet.png') no-repeat -203px -57px;\r\n}\r\n#requestDaysOnOffModal .searchbox {\r\n  border-color: #ddd;\r\n  background-color: #fff;\r\n}\r\n#requestDaysOnOffModal .searchbox .l-btn-plain {\r\n  background: #ffffff;\r\n}\r\n#requestDaysOnOffModal .searchbox .l-btn-plain-disabled,\r\n#requestDaysOnOffModal .searchbox .l-btn-plain-disabled:hover {\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n}\r\n#requestDaysOnOffModal .slider-disabled {\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n}\r\n#requestDaysOnOffModal .slider-h {\r\n  height: 22px;\r\n}\r\n#requestDaysOnOffModal .slider-v {\r\n  width: 22px;\r\n}\r\n#requestDaysOnOffModal .slider-inner {\r\n  position: relative;\r\n  height: 6px;\r\n  top: 7px;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-radius: 0px;\r\n}\r\n#requestDaysOnOffModal .slider-handle {\r\n  position: absolute;\r\n  display: block;\r\n  outline: none;\r\n  width: 20px;\r\n  height: 20px;\r\n  top: -7px;\r\n  margin-left: -10px;\r\n}\r\n#requestDaysOnOffModal .slider-tip {\r\n  position: absolute;\r\n  display: inline-block;\r\n  line-height: 12px;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  top: -22px;\r\n}\r\n#requestDaysOnOffModal .slider-rule {\r\n  position: relative;\r\n  top: 15px;\r\n}\r\n#requestDaysOnOffModal .slider-rule span {\r\n  position: absolute;\r\n  display: inline-block;\r\n  font-size: 0;\r\n  height: 5px;\r\n  border-width: 0 0 0 1px;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .slider-rulelabel {\r\n  position: relative;\r\n  top: 20px;\r\n}\r\n#requestDaysOnOffModal .slider-rulelabel span {\r\n  position: absolute;\r\n  display: inline-block;\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .slider-v .slider-inner {\r\n  width: 6px;\r\n  left: 7px;\r\n  top: 0;\r\n  float: left;\r\n}\r\n#requestDaysOnOffModal .slider-v .slider-handle {\r\n  left: 3px;\r\n  margin-top: -10px;\r\n}\r\n#requestDaysOnOffModal .slider-v .slider-tip {\r\n  left: -10px;\r\n  margin-top: -6px;\r\n}\r\n#requestDaysOnOffModal .slider-v .slider-rule {\r\n  float: left;\r\n  top: 0;\r\n  left: 16px;\r\n}\r\n#requestDaysOnOffModal .slider-v .slider-rule span {\r\n  width: 5px;\r\n  height: 'auto';\r\n  border-left: 0;\r\n  border-width: 1px 0 0 0;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .slider-v .slider-rulelabel {\r\n  float: left;\r\n  top: 0;\r\n  left: 23px;\r\n}\r\n#requestDaysOnOffModal .slider-handle {\r\n  background: url('images/slider_handle.png') no-repeat;\r\n}\r\n#requestDaysOnOffModal .slider-inner {\r\n  border-color: #ddd;\r\n  background: #ffffff;\r\n}\r\n#requestDaysOnOffModal .slider-rule span {\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .slider-rulelabel span {\r\n  color: #444;\r\n}\r\n#requestDaysOnOffModal .menu {\r\n  position: absolute;\r\n  margin: 0;\r\n  padding: 2px;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .menu-item {\r\n  position: relative;\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n#requestDaysOnOffModal .menu-text {\r\n  height: 20px;\r\n  line-height: 20px;\r\n  float: left;\r\n  padding-left: 28px;\r\n}\r\n#requestDaysOnOffModal .menu-icon {\r\n  position: absolute;\r\n  width: 16px;\r\n  height: 16px;\r\n  left: 2px;\r\n  top: 50%;\r\n  margin-top: -8px;\r\n}\r\n#requestDaysOnOffModal .menu-rightarrow {\r\n  position: absolute;\r\n  width: 16px;\r\n  height: 16px;\r\n  right: 0;\r\n  top: 50%;\r\n  margin-top: -8px;\r\n}\r\n#requestDaysOnOffModal .menu-line {\r\n  position: absolute;\r\n  left: 26px;\r\n  top: 0;\r\n  height: 2000px;\r\n  font-size: 1px;\r\n}\r\n#requestDaysOnOffModal .menu-sep {\r\n  margin: 3px 0px 3px 25px;\r\n  font-size: 1px;\r\n}\r\n#requestDaysOnOffModal .menu-active {\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .menu-item-disabled {\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n  cursor: default;\r\n}\r\n#requestDaysOnOffModal .menu-text,\r\n#requestDaysOnOffModal .menu-text span {\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .menu-shadow {\r\n  position: absolute;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n  background: #eee;\r\n  -moz-box-shadow: 2px 2px 3px #ededed;\r\n  -webkit-box-shadow: 2px 2px 3px #ededed;\r\n  box-shadow: 2px 2px 3px #ededed;\r\n  filter: progid:DXImageTransform.Microsoft.Blur(pixelRadius=2,MakeShadow=false,ShadowOpacity=0.2);\r\n}\r\n#requestDaysOnOffModal .menu-rightarrow {\r\n    background: url('spritesheet.png') no-repeat -57px -57px;\r\n}\r\n#requestDaysOnOffModal .menu-line {\r\n  border-left: 1px solid #ddd;\r\n  border-right: 1px solid #fff;\r\n}\r\n#requestDaysOnOffModal .menu-sep {\r\n  border-top: 1px solid #ddd;\r\n  border-bottom: 1px solid #fff;\r\n}\r\n#requestDaysOnOffModal .menu {\r\n  background-color: #ffffff;\r\n  border-color: #ddd;\r\n  color: #444;\r\n}\r\n#requestDaysOnOffModal .menu-content {\r\n  background: #fff;\r\n}\r\n#requestDaysOnOffModal .menu-item {\r\n  border-color: transparent;\r\n  _border-color: #ffffff;\r\n}\r\n#requestDaysOnOffModal .menu-active {\r\n  border-color: #ddd;\r\n  color: #444;\r\n  background: #E6E6E6;\r\n}\r\n#requestDaysOnOffModal .menu-active-disabled {\r\n  border-color: transparent;\r\n  background: transparent;\r\n  color: #444;\r\n}\r\n#requestDaysOnOffModal .m-btn-downarrow,\r\n#requestDaysOnOffModal .s-btn-downarrow {\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 16px;\r\n  height: 16px;\r\n  font-size: 1px;\r\n  right: 0;\r\n  top: 50%;\r\n  margin-top: -8px;\r\n}\r\n#requestDaysOnOffModal .m-btn-active,\r\n#requestDaysOnOffModal .s-btn-active {\r\n  background: #E6E6E6;\r\n  color: #444;\r\n  border: 1px solid #ddd;\r\n  filter: none;\r\n}\r\n#requestDaysOnOffModal .m-btn-plain-active,\r\n#requestDaysOnOffModal .s-btn-plain-active {\r\n  background: transparent;\r\n  padding: 0;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .m-btn .l-btn-left .l-btn-text {\r\n  margin-right: 20px;\r\n}\r\n#requestDaysOnOffModal .m-btn .l-btn-icon-right .l-btn-text {\r\n  margin-right: 40px;\r\n}\r\n#requestDaysOnOffModal .m-btn .l-btn-icon-right .l-btn-icon {\r\n  right: 20px;\r\n}\r\n#requestDaysOnOffModal .m-btn .l-btn-icon-top .l-btn-text {\r\n  margin-right: 4px;\r\n  margin-bottom: 14px;\r\n}\r\n#requestDaysOnOffModal .m-btn .l-btn-icon-bottom .l-btn-text {\r\n  margin-right: 4px;\r\n  margin-bottom: 34px;\r\n}\r\n#requestDaysOnOffModal .m-btn .l-btn-icon-bottom .l-btn-icon {\r\n  top: auto;\r\n  bottom: 20px;\r\n}\r\n#requestDaysOnOffModal .m-btn .l-btn-icon-top .m-btn-downarrow,\r\n#requestDaysOnOffModal .m-btn .l-btn-icon-bottom .m-btn-downarrow {\r\n  top: auto;\r\n  bottom: 0px;\r\n  left: 50%;\r\n  margin-left: -8px;\r\n}\r\n#requestDaysOnOffModal .m-btn-line {\r\n  display: inline-block;\r\n  position: absolute;\r\n  font-size: 1px;\r\n  display: none;\r\n}\r\n#requestDaysOnOffModal .m-btn .l-btn-left .m-btn-line {\r\n  right: 0;\r\n  width: 16px;\r\n  height: 500px;\r\n  border-style: solid;\r\n  border-color: #b3b3b3;\r\n  border-width: 0 0 0 1px;\r\n}\r\n#requestDaysOnOffModal .m-btn .l-btn-icon-top .m-btn-line,\r\n#requestDaysOnOffModal .m-btn .l-btn-icon-bottom .m-btn-line {\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 500px;\r\n  height: 16px;\r\n  border-width: 1px 0 0 0;\r\n}\r\n#requestDaysOnOffModal .m-btn-large .l-btn-icon-right .l-btn-text {\r\n  margin-right: 56px;\r\n}\r\n#requestDaysOnOffModal .m-btn-large .l-btn-icon-bottom .l-btn-text {\r\n  margin-bottom: 50px;\r\n}\r\n#requestDaysOnOffModal .m-btn-downarrow,\r\n#requestDaysOnOffModal .s-btn-downarrow {\r\n    background: url('spritesheet.png') no-repeat -83px -57px;\r\n}\r\n#requestDaysOnOffModal .m-btn-plain-active,\r\n#requestDaysOnOffModal .s-btn-plain-active {\r\n  border-color: #ddd;\r\n  background-color: #E6E6E6;\r\n  color: #444;\r\n}\r\n#requestDaysOnOffModal .s-btn:hover .m-btn-line,\r\n#requestDaysOnOffModal .s-btn-active .m-btn-line,\r\n#requestDaysOnOffModal .s-btn-plain-active .m-btn-line {\r\n  display: inline-block;\r\n}\r\n#requestDaysOnOffModal .l-btn:hover .s-btn-downarrow,\r\n#requestDaysOnOffModal .s-btn-active .s-btn-downarrow,\r\n#requestDaysOnOffModal .s-btn-plain-active .s-btn-downarrow {\r\n  border-style: solid;\r\n  border-color: #b3b3b3;\r\n  border-width: 0 0 0 1px;\r\n}\r\n#requestDaysOnOffModal .messager-body {\r\n  padding: 10px;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .messager-button {\r\n  text-align: center;\r\n  padding-top: 10px;\r\n}\r\n#requestDaysOnOffModal .messager-button .l-btn {\r\n  width: 70px;\r\n}\r\n#requestDaysOnOffModal .messager-icon {\r\n  float: left;\r\n  width: 32px;\r\n  height: 32px;\r\n  margin: 0 10px 10px 0;\r\n}\r\n#requestDaysOnOffModal .messager-error {\r\n    background: url('spritesheet.png') no-repeat -161px -57px;\r\n}\r\n#requestDaysOnOffModal .messager-info {\r\n    background: url('spritesheet.png') no-repeat -5px -99px;\r\n}\r\n#requestDaysOnOffModal .messager-question {\r\n    background: url('spritesheet.png') no-repeat -47px -99px;\r\n}\r\n#requestDaysOnOffModal .messager-warning {\r\n    background: url('spritesheet.png') no-repeat -89px -99px;\r\n}\r\n#requestDaysOnOffModal .messager-progress {\r\n  padding: 10px;\r\n}\r\n#requestDaysOnOffModal .messager-p-msg {\r\n  margin-bottom: 5px;\r\n}\r\n#requestDaysOnOffModal .messager-body .messager-input {\r\n  width: 100%;\r\n  padding: 1px 0;\r\n  border: 1px solid #ddd;\r\n}\r\n#requestDaysOnOffModal .tree {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style-type: none;\r\n}\r\n#requestDaysOnOffModal .tree li {\r\n  white-space: nowrap;\r\n}\r\n#requestDaysOnOffModal .tree li ul {\r\n  list-style-type: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n#requestDaysOnOffModal .tree-node {\r\n  height: 18px;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n}\r\n#requestDaysOnOffModal .tree-hit {\r\n  cursor: pointer;\r\n}\r\n#requestDaysOnOffModal .tree-expanded,\r\n#requestDaysOnOffModal .tree-collapsed,\r\n#requestDaysOnOffModal .tree-folder,\r\n#requestDaysOnOffModal .tree-file,\r\n#requestDaysOnOffModal .tree-checkbox,\r\n#requestDaysOnOffModal .tree-indent {\r\n  display: inline-block;\r\n  width: 16px;\r\n  height: 18px;\r\n  vertical-align: top;\r\n  overflow: hidden;\r\n}\r\n#requestDaysOnOffModal .tree-expanded {\r\n  background: url('images/tree_icons.png') no-repeat -18px 0px;\r\n}\r\n#requestDaysOnOffModal .tree-expanded-hover {\r\n  background: url('images/tree_icons.png') no-repeat -50px 0px;\r\n}\r\n#requestDaysOnOffModal .tree-collapsed {\r\n  background: url('images/tree_icons.png') no-repeat 0px 0px;\r\n}\r\n#requestDaysOnOffModal .tree-collapsed-hover {\r\n  background: url('images/tree_icons.png') no-repeat -32px 0px;\r\n}\r\n#requestDaysOnOffModal .tree-lines .tree-expanded,\r\n#requestDaysOnOffModal .tree-lines .tree-root-first .tree-expanded {\r\n  background: url('images/tree_icons.png') no-repeat -144px 0;\r\n}\r\n#requestDaysOnOffModal .tree-lines .tree-collapsed,\r\n#requestDaysOnOffModal .tree-lines .tree-root-first .tree-collapsed {\r\n  background: url('images/tree_icons.png') no-repeat -128px 0;\r\n}\r\n#requestDaysOnOffModal .tree-lines .tree-node-last .tree-expanded,\r\n#requestDaysOnOffModal .tree-lines .tree-root-one .tree-expanded {\r\n  background: url('images/tree_icons.png') no-repeat -80px 0;\r\n}\r\n#requestDaysOnOffModal .tree-lines .tree-node-last .tree-collapsed,\r\n#requestDaysOnOffModal .tree-lines .tree-root-one .tree-collapsed {\r\n  background: url('images/tree_icons.png') no-repeat -64px 0;\r\n}\r\n#requestDaysOnOffModal .tree-line {\r\n  background: url('images/tree_icons.png') no-repeat -176px 0;\r\n}\r\n#requestDaysOnOffModal .tree-join {\r\n  background: url('images/tree_icons.png') no-repeat -192px 0;\r\n}\r\n#requestDaysOnOffModal .tree-joinbottom {\r\n  background: url('images/tree_icons.png') no-repeat -160px 0;\r\n}\r\n#requestDaysOnOffModal .tree-folder {\r\n  background: url('images/tree_icons.png') no-repeat -208px 0;\r\n}\r\n#requestDaysOnOffModal .tree-folder-open {\r\n  background: url('images/tree_icons.png') no-repeat -224px 0;\r\n}\r\n#requestDaysOnOffModal .tree-file {\r\n  background: url('images/tree_icons.png') no-repeat -240px 0;\r\n}\r\n#requestDaysOnOffModal .tree-loading {\r\n  background: url('images/loading.gif') no-repeat center center;\r\n}\r\n#requestDaysOnOffModal .tree-checkbox0 {\r\n  background: url('images/tree_icons.png') no-repeat -208px -18px;\r\n}\r\n#requestDaysOnOffModal .tree-checkbox1 {\r\n  background: url('images/tree_icons.png') no-repeat -224px -18px;\r\n}\r\n#requestDaysOnOffModal .tree-checkbox2 {\r\n  background: url('images/tree_icons.png') no-repeat -240px -18px;\r\n}\r\n#requestDaysOnOffModal .tree-title {\r\n  font-size: 12px;\r\n  display: inline-block;\r\n  text-decoration: none;\r\n  vertical-align: top;\r\n  white-space: nowrap;\r\n  padding: 0 2px;\r\n  height: 18px;\r\n  line-height: 18px;\r\n}\r\n#requestDaysOnOffModal .tree-node-proxy {\r\n  font-size: 12px;\r\n  line-height: 20px;\r\n  padding: 0 2px 0 20px;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  z-index: 9900000;\r\n}\r\n#requestDaysOnOffModal .tree-dnd-icon {\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 16px;\r\n  height: 18px;\r\n  left: 2px;\r\n  top: 50%;\r\n  margin-top: -9px;\r\n}\r\n#requestDaysOnOffModal .tree-dnd-yes {\r\n  background: url('images/tree_icons.png') no-repeat -256px 0;\r\n}\r\n#requestDaysOnOffModal .tree-dnd-no {\r\n  background: url('images/tree_icons.png') no-repeat -256px -18px;\r\n}\r\n#requestDaysOnOffModal /*.tree-node-top {\r\n  border-top: 1px dotted red;\r\n}\r\n.tree-node-bottom {\r\n  border-bottom: 1px dotted red;\r\n}*/\r\n#requestDaysOnOffModal .tree-node-append .tree-title {\r\n  border: 1px dotted red;\r\n}\r\n#requestDaysOnOffModal .tree-editor {\r\n  border: 1px solid #ccc;\r\n  font-size: 12px;\r\n  height: 14px !important;\r\n  height: 18px;\r\n  line-height: 14px;\r\n  padding: 1px 2px;\r\n  width: 80px;\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n#requestDaysOnOffModal .tree-node-proxy {\r\n  background-color: #fff;\r\n  color: #444;\r\n  border-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .tree-node-hover {\r\n  background: #E6E6E6;\r\n  color: #444;\r\n}\r\n#requestDaysOnOffModal .tree-node-selected {\r\n  background: #CCE6FF;\r\n  color: #000;\r\n}\r\n#requestDaysOnOffModal .validatebox-invalid {\r\n  background-image: url('images/validatebox_warning.png');\r\n  background-repeat: no-repeat;\r\n  background-position: right center;\r\n  border-color: #ffa8a8;\r\n  background-color: #fff3f3;\r\n  color: #000;\r\n}\r\n#requestDaysOnOffModal .tooltip {\r\n  position: absolute;\r\n  display: none;\r\n  z-index: 9900000;\r\n  outline: none;\r\n  opacity: 1;\r\n  filter: alpha(opacity=100);\r\n  padding: 5px;\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-radius: 5px;\r\n  -moz-border-radius: 0px 0px 0px 0px;\r\n  -webkit-border-radius: 0px 0px 0px 0px;\r\n  border-radius: 0px 0px 0px 0px;\r\n}\r\n#requestDaysOnOffModal .tooltip-content {\r\n  font-size: 12px;\r\n}\r\n#requestDaysOnOffModal .tooltip-arrow-outer,\r\n#requestDaysOnOffModal .tooltip-arrow {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  line-height: 0;\r\n  font-size: 0;\r\n  border-style: solid;\r\n  border-width: 6px;\r\n  border-color: transparent;\r\n  _border-color: tomato;\r\n  _filter: chroma(color=tomato);\r\n}\r\n#requestDaysOnOffModal .tooltip-right .tooltip-arrow-outer {\r\n  left: 0;\r\n  top: 50%;\r\n  margin: -6px 0 0 -13px;\r\n}\r\n#requestDaysOnOffModal .tooltip-right .tooltip-arrow {\r\n  left: 0;\r\n  top: 50%;\r\n  margin: -6px 0 0 -12px;\r\n}\r\n#requestDaysOnOffModal .tooltip-left .tooltip-arrow-outer {\r\n  right: 0;\r\n  top: 50%;\r\n  margin: -6px -13px 0 0;\r\n}\r\n#requestDaysOnOffModal .tooltip-left .tooltip-arrow {\r\n  right: 0;\r\n  top: 50%;\r\n  margin: -6px -12px 0 0;\r\n}\r\n#requestDaysOnOffModal .tooltip-top .tooltip-arrow-outer {\r\n  bottom: 0;\r\n  left: 50%;\r\n  margin: 0 0 -13px -6px;\r\n}\r\n#requestDaysOnOffModal .tooltip-top .tooltip-arrow {\r\n  bottom: 0;\r\n  left: 50%;\r\n  margin: 0 0 -12px -6px;\r\n}\r\n#requestDaysOnOffModal .tooltip-bottom .tooltip-arrow-outer {\r\n  top: 0;\r\n  left: 50%;\r\n  margin: -13px 0 0 -6px;\r\n}\r\n#requestDaysOnOffModal .tooltip-bottom .tooltip-arrow {\r\n  top: 0;\r\n  left: 50%;\r\n  margin: -12px 0 0 -6px;\r\n}\r\n#requestDaysOnOffModal .tooltip {\r\n  background-color: #fff;\r\n  border-color: #ddd;\r\n  color: #444;\r\n}\r\n#requestDaysOnOffModal .tooltip-right .tooltip-arrow-outer {\r\n  border-right-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .tooltip-right .tooltip-arrow {\r\n  border-right-color: #fff;\r\n}\r\n#requestDaysOnOffModal .tooltip-left .tooltip-arrow-outer {\r\n  border-left-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .tooltip-left .tooltip-arrow {\r\n  border-left-color: #fff;\r\n}\r\n#requestDaysOnOffModal .tooltip-top .tooltip-arrow-outer {\r\n  border-top-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .tooltip-top .tooltip-arrow {\r\n  border-top-color: #fff;\r\n}\r\n#requestDaysOnOffModal .tooltip-bottom .tooltip-arrow-outer {\r\n  border-bottom-color: #ddd;\r\n}\r\n#requestDaysOnOffModal .tooltip-bottom .tooltip-arrow {\r\n  border-bottom-color: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
